
<div id="allContent" style="border-left: 5px solid rgb(207, 121, 1);;border-right: 5px solid rgb(207, 121, 1);  font-size: 12px;" >

  <div class="backgroundTela">
    &nbsp;
  </div>

  <mat-tab-group [(selectedIndex)]="indexMenu" (selectedTabChange)="aoMudarMenu(indexMenu);"  animationDuration="100ms" style=" margin-left: 5px; margin-top: 0px;">
    <!--MENU FICHAS -->
    <mat-tab *ngFor="let menu of [0];let i=index;" label="📝 Fichas de monitoria" >
      <form [formGroup]="formulario" novalidate >

          <!--Definir o tamanho da tela-->
          <div style=" width: 100%; overflow:hidden; text-align: center;">
            <div style="width: 100%; height: 60px; background-color: rgb(51, 68, 75); text-align: center;">
                  <table style="width: 100%; margin-left: 2px;">
                    <tr>
                      

                      <td style="width: 32%; text-align: right;">
                        <mat-card style="padding: 0px; width: 100%;  height: 47px; margin: auto; margin-top: 5px;">
                          <mat-form-field appearance="outline" style="width: 100%; font-size: 11px; text-align: center;">
                            <mat-label style="text-align: left;">
                              <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                              <b> Operação</b>
                              <i>(Empresa)</i>
                            </mat-label>
                            <mat-select formControlName="operacao"  (selectionChange)="onChangeOperacao('null')"
                                          style="text-align: center; font-size: 12px; font-weight: 500;">
                              <mat-option *ngFor="let colunas of lstCmbOperacao"
                                          [value]="colunas.operIdCdOperacao">{{colunas.operNmOperacao}}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </mat-card>
                      </td>
                      
                      <!--<td style="width: 6%;" *ngIf="formulario.controls['operacao'].value > 0 && (formulario.controls['idFichaMonitoria'].value == 0 || formulario.controls['idFichaMonitoria'].value =='') ">-->
                      <td style="width: 6%;" *ngIf="false">
                        <button  mat-stroked-button class="eye-button" type="button" 
                          (click) = "addNovoFormulario()" matTooltip="Criar novo Formulario">
                          <mat-icon class="eye-icon">add</mat-icon>
                        </button>
                      </td>
                      
                      <td style="width: 21%; text-align: center; margin-left: 2px; ">
                        <mat-card style="padding: 0px; width: 100%;   height: 47px; margin: auto; margin-top: 5px; font-size: 12px;">
                         
                          <mat-radio-group formControlName="formAtivo"  >

                            <mat-radio-button value="ativo" (checked)="true"  (change)="onChangeOperacao($event);" style="margin-top: 10px;">
                              <label style="margin-left: -5px; margin-top: 6px; ">
                                Ativos &nbsp;
                              </label>
                            </mat-radio-button>
                            &nbsp;
                            <mat-radio-button value="inativo" (change)="onChangeOperacao($event);" style="margin-top: 10px;">
                              <label style="margin-left: -5px; margin-top: 6px; ">
                                Inativos &nbsp;
                              </label>
                            </mat-radio-button>
                            &nbsp;
                          </mat-radio-group>
                        </mat-card>
                      </td>
                     
                      <td style="width: 32%; text-align: center; margin-left: 2px;">

                        <mat-card *ngIf="lstBeanFormulario != null && lstBeanFormulario.length > 0"
                                    style="padding: 0px; height: 47px;  margin-top: 5px;" >
                          <mat-form-field appearance="outline" style="width: 100%; font-size: 11px; text-align: center;">
                            <mat-label style="text-align: left;">
                              <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                              <b> Formulário</b>
                            </mat-label>
                            <mat-select formControlName="idForm" (selectionChange)="onChangeForm($event)"
                                          style="text-align: center; font-size: 12px; font-weight: 500;">
                                <mat-option *ngFor="let colunas of lstBeanFormulario"
                                          [value]="colunas.formIdCdFormulario">{{colunas.formDsFormulario}}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </mat-card>

                        <mat-card *ngIf="lstBeanFormulario == null || lstBeanFormulario.length == 0"
                                  style="padding: 0px; height: 47px; margin-right: 5px; margin-top: 5px; background-color: rgb(212, 212, 212);">
                          <mat-form-field appearance="outline" style="width: 100%; font-size: 11px; text-align: center;">
                            <mat-label style="text-align: left;">
                              <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                              <b> Selecione uma forma de busca</b>
                            </mat-label>
                            <input matInput disabled="true">
                          </mat-form-field>
                        </mat-card>
                      </td>
                      <td style="width: 4%; " *ngIf="formulario.controls['idForm'].value != '' && formulario.controls['idForm'].value > 0" >
                         <label class="eye-button" (click)="loadDialogPreviaFormulario()" matTooltip="Visualizar prévia">
                            <div style="width: 100%; height: 100%; margin-top: 8px;">
                              <mat-icon class="eye-icon">visibility</mat-icon>
                            </div>
                         </label>
                      </td>
                      <td style="width: 4%;" *ngIf="formulario.controls['idForm'].value != '' && formulario.controls['idForm'].value > 0" >
                        <label class="copia-formulario-button" (click)="loadDialogDuplicarFormulario()" matTooltip="Duplicar este formulário">
                          <div style="width: 100%; height: 100%; margin-top: 10px;">
                            &#10113;
                          </div>
                        </label>
                      </td>
                     
                    </tr>
                  </table>
            </div>
            <div style="margin-top: 0px; height: 5px; width: 100%; background-color: rgb(180, 180, 180)">&nbsp;</div>
          </div>

          <div *ngIf="!podeAlterarFormulario && this.formulario.controls['idFichaMonitoria'].value > 0 " style="width: 100%; margin-top: 50px; text-align: center;">
            
            
            <table style="width: 100%; ">
              <tr>
                <td style="width: 63%; color:rgb(207, 121, 1)">
                  <b>Existe uma ou mais fichas de monitorias geradas para este formulário </b>.
                  <br>Para preservar seu(s) histórico(s) <b>não será possivel novas edições</b>.
                  <br/><br/>
                  Está liberado visualizar a estrtutura do formuário em [ <label ><mat-icon style="vertical-align: bottom; color: green;" class="eye-icon">visibility</mat-icon></label> ] ou inativa-lo.
                </td>
                <td style="width: 36%; height: 100%; ">
                                      
                    <div style="width: 75%; float: left; text-align: center;">
                      <mat-slide-toggle formControlName="inativoFicha" style="font-size: 12px; ">Cadastro inativo?</mat-slide-toggle>    
                    </div>
                    <div style="width: 1%; float: left; text-align: right;">
                     &nbsp; 
                    </div>
                    <div style="width: 23%; float: left;  ">
                      <button mat-raised-button  type="submit"
                        style="background-color: rgb(46, 163, 80); color: #fff; width: 99%;  font-size: 12px; " 
                        (click) = "formSalvar()">
                        salvar
                      </button>
                    </div>
                    <div style="width: 1%; float: left; text-align: right;">
                      &nbsp; 
                     </div>
                                      
                </td>
                <td style="width: 1%;">
                  &nbsp;
                </td>
              </tr>
            </table>

          </div>


          <mat-tab-group *ngIf="podeAlterarFormulario" [(selectedIndex)]="indexFormulario" (selectedTabChange)="aoMudarSubMenu(indexMenu, indexFormulario, null);"
              animationDuration="100ms" style="margin-top: 10px; " style="margin-top: -12px;">

              <!-- Formulário -->
              <mat-tab *ngFor="let subMenu of [0];let i=index;"  label="📝 Formulário " disabled={{disabledTab}}>

                    <div style="margin-top: 8px;">
                      <!--container ajustado dinamicamente-->
                      <div id="divContainer">

                        <div id="divAdjustAutoHeight">

                          <div style="margin-left: 5px; margin-right: 5px;">

                            <!--DIV ESQUERDA-->
                            <div>

                              <div style="background-color: rgb(51, 68, 75); height: 30px; width: 100%; color: white; text-align: center; border-radius: 30px 30px 0px 0px;">
                                <div style=" margin-left: 15px; font-size: 14px;">Novo / Editar cadastro</div>
                              </div>
                              <div style="margin-top: 0px; height: 5px; width: 100%; background-color: rgb(180, 180, 180)">&nbsp;</div>


                              <mat-card *ngIf="this.formulario.controls['operacao'].value == ''" class="mat-elevation-z8" style="padding: 8px; text-align: center;">

                                Consulta feita na parte superior [ Aba fichas de monitoria ]

                              </mat-card>


                              <mat-card *ngIf="this.formulario.controls['operacao'].value != ''" class="mat-elevation-z8" style="padding: 8px;">



                                  <!--container ajustado dinamicamente-->
                                  <div id="subDivContainer" style="width: 100%; ">
                                      <div id="subDivAdjustAutoHeight" style="overflow-y: auto;">



                                        <div style="width: 100%;">

                                          <div style="width: 11%; float: left;">
                                            <mat-form-field appearance="outline" style="font-family: 'Poppins-ExtraLight'; font-size: 12px;" >
                                              <mat-label>
                                                <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                                <b> Versão**</b>
                                              </mat-label>
                                              <input matInput formControlName="versaoFicha" maxlength="200" onchange="this.value = this.value.toUpperCase()">
                                            </mat-form-field>
                                          </div>
                                          <div style="width: 01%; float: left;">
                                            &nbsp;
                                          </div>
                                          <div style="width: 60%;  float: left;">
                                            <mat-card style="padding: 0px; margin-top: 10px; width: 100%; height: 45px; background-color: rgb(255, 240, 242);  cursor: pointer;">
                                              <mat-form-field appearance="outline" style="font-family: 'Poppins-ExtraLight'; font-size: 12px;" >
                                                <mat-label>
                                                  <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                                  <b> Nome da Ficha de Monitoria</b> **
                                                  <i>*</i>
                                                </mat-label>
                                                <input matInput formControlName="fichaMonitoria" maxlength="200" onchange="this.value = this.value.toUpperCase()">
                                              </mat-form-field>
                                            </mat-card>
                                          </div>
                                          <div style="width: 01%; float: left;">
                                            &nbsp;
                                          </div>
                                          <div style="width: 27%; float: left;">
                                            <mat-form-field appearance="outline" style="font-family: 'Poppins-ExtraLight'; font-size: 12px;" >
                                              <mat-label>
                                                <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                                <b> Segmento</b>
                                                <i>*</i>
                                              </mat-label>
                                              <input matInput formControlName="segmento" maxlength="200" onchange="this.value = this.value.toUpperCase()">
                                            </mat-form-field>
                                          </div>


                                          <br/> <br/> <br/>

                                        </div>



                                        <div style="width:100%;  text-align: left; margin-top: 18px;">
                                          <table style="width: 100%;">
                                            <tr>
                                              <td style="width: 50%;">
                                                <div style="width: 100%; float: left;">
                                                  <mat-slide-toggle formControlName="inativoFicha" style="font-size: 12px;">Cadastro inativo?</mat-slide-toggle>     
                                                </div>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td style="width: 50%;">
                                                <br>


                                                <div style="width: 100%;  font-size: 12px;">
                                                  
                                                  <mat-radio-group formControlName="tipoFormulario" aria-label="Selecione um tipo de formulário"
                                                    [disabled]="this.formulario.controls['idFichaMonitoria'].value > 0 ? true : false">
                                                    <mat-label style="vertical-align: top; color: rgba(0,0,0,.6); margin-left: 10px;"><b>Tipo: </b></mat-label>
                                                    <mat-radio-button value="M" checked style="margin-left: 5px;">Monitoria</mat-radio-button>
                                                    <mat-radio-button value="A">Avaliação de Desempenho</mat-radio-button>
                                                  </mat-radio-group>

                                                  <mat-radio-group formControlName="formDsTipoPontuacao"  >
                                                    <mat-label style="vertical-align: top; color: rgba(0,0,0,.6); margin-left: 50px;"><b>Totalizador de Pontos: </b></mat-label>
                                                    <mat-radio-button value="SOMA" (checked)="true" style="margin-left: 5px;">Soma</mat-radio-button>                                                    
                                                    <mat-radio-button value="MEDIA">Média</mat-radio-button>                                                    
                                                  </mat-radio-group>   
                                                  
                                                  
                                                                                            
                                                </div>                                                
                                                
                                                <br>

                                                <div style="width: 100%;  font-size: 12px;">
                                                  <div style="width: 73%; float: left;">&nbsp;</div>
                                                  <div style="width: 17%; float: left;">
                                                    <button mat-raised-button  type="submit"
                                                      style="background-color: rgb(46, 163, 80); color: #fff; width: 99%;  font-size: 12px;" (click) = "formSalvar()">
                                                      {{ this.formulario.controls['idFichaMonitoria'].value > 0 ? 'Editar' : 'Criar novo' }}
                                                    </button>
                                                  </div>
                                                  <div style="width: 10%; float: left;">
                                                    <button mat-raised-button color="warn" style="color: #fff; width: 99%; font-size: 12px;"(click) = "formCancelar()">
                                                      Cancelar
                                                    </button>
                                                  </div>

                                                </div>
                                               

                                              </td>
                                            </tr>

                                          </table>
                                        </div>




                                          <div style="width:100%;  text-align: left; margin-top: 18px;">

                                          </div>




                                          <div style="width: 100%; margin-top: 25px;">

                                            <div style="width: 70%; float: left;">

                                            </div>
                                            <div style="width: 30%; float: left;">

                                            </div>

                                          </div>

                                      </div>

                                  </div>

                              </mat-card>

                            </div>



                            <!--DIV DIREITA-->
                            <!--container ajustado dinamicamente-->

                            <div>

                              <div style="margin-top: 0px; height: 5px; width: 100%; background-color: rgb(180, 180, 180)">&nbsp;</div>


                                  <mat-card class="mat-elevation-z8" style="padding: 8px; text-align: center;">

                                   &nbsp;


                                  </mat-card>

                            </div>

                          </div>

                        </div>



                      </div>

                    </div>

              </mat-tab>

              <!-- Cabeçalho do formulario -->
              <mat-tab *ngFor="let subMenu of [1];let i=index;"  label="📝 Cabeçalho do formulario " disabled={{disabledTab}}>

                <mat-tab-group [(selectedIndex)]="indexCabecalho" (selectedTabChange)="aoMudarSubMenu(indexMenu, subMenu, indexCabecalho);" animationDuration="100ms" style="margin-top: 10px; ">

                  <!-- Cabeçalho -->
                  <mat-tab *ngFor="let subMenu of [0];let i=index;"  label="📝 Cabeçalho " disabled={{disabledTab}}>
                    <div style="margin-top: 8px;">
                          <!--container ajustado dinamicamente-->
                          <div id="divContainer" style="width: 99%;">

                            <div id="divAdjustAutoHeight" style="overflow-y: hidden;">

                              <div style="margin-left: 5px; margin-right: 5px;">

                              <!--DIV ESQUERDA-->
                              <div>

                                <div style="background-color: rgb(51, 68, 75); height: 30px; width: 100%; color: white; text-align: center; border-radius: 30px 30px 0px 0px;">
                                  <div style=" margin-left: 15px; font-size: 14px;">Novo / Editar cadastro</div>
                                </div>
                                <div style="margin-top: 0px; height: 5px; width: 100%; background-color: rgb(180, 180, 180)">&nbsp;</div>


                                <mat-card class="mat-elevation-z8" style="padding: 8px;">

                                    <!--container ajustado dinamicamente-->
                                    <div id="subDivContainer" style="width: 100%;">
                                        <div id="subDivAdjustAutoHeight" style="overflow-y: auto;">



                                          <div style="width: 100%;">

                                            <div style="width: 12%; float: left;">
                                              <mat-form-field appearance="outline" style="width: 100%; font-family: 'Poppins-ExtraLight'; font-size: 12px;" >
                                                <mat-label>
                                                  <b>Ordem**</b>
                                                </mat-label>
                                                <input matInput type="number" formControlName="paraNrOrdem" style="font-weight: bold;" onchange="this.value = this.value.toUpperCase()">
                                              </mat-form-field>
                                            </div>
                                            <div style="width: 01%; float: left;">
                                              &nbsp;
                                            </div>
                                            <div style="width: 87%;  float: left;">
                                              <mat-card style="padding: 0px; margin-top: 10px; width: 100%; height: 45px; background-color: rgb(255, 240, 242);  cursor: pointer;">
                                                <mat-form-field appearance="outline" style="font-family: 'Poppins-ExtraLight';" >
                                                  <mat-label>
                                                  <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                                  <b> Nome do Campo</b>
                                                  <i>*</i>
                                                  </mat-label>
                                                  <input matInput formControlName="paraDsParametro" maxlength="200" onchange="this.value = this.value.toUpperCase()">
                                              </mat-form-field>
                                              </mat-card>
                                            </div>

                                            <br/> <br/> <br/>

                                          </div>



                                          <div style="width:100%;  text-align: left; margin-top: 18px;">
                                            <table style="width: 100%;">
                                              <tr>
                                                <td style="width: 50%;">
                                                  <div style="width: 13%; float: left;">
                                                    &nbsp;
                                                  </div>
                                                  <div style="width: 20%; float: left;">
                                                    <mat-slide-toggle formControlName="paraDhInativo" style="font-size: 12px; ">Cadastro inativo?</mat-slide-toggle>
                                                  </div>
                                                  <div style="width: 40%;  float: left;">
                                                    <mat-slide-toggle formControlName="paraInObrigatorio" style="font-size: 12px; ">Obrigatório?</mat-slide-toggle>
                                                  </div>
                                                  <div style="width: 17%; float: left;">
                                                    <button mat-raised-button  type="submit"
                                                      style="background-color: rgb(46, 163, 80); color: #fff; width: 99%;  font-size: 12px;" (click) = "salvarCabecalho()">
                                                      {{ this.formulario.controls['idParametro'].value > 0 ? 'Editar' : 'Criar novo' }}
                                                    </button>
                                                  </div>
                                                  <div style="width: 10%; float: left;">
                                                    <button mat-raised-button color="warn" style="color: #fff; width: 99%; font-size: 12px;"(click) = "cancelarCabecalho()">
                                                      Cancelar
                                                    </button>
                                                  </div>

                                                </td>
                                              </tr>

                                            </table>
                                          </div>


                                        </div>

                                    </div>

                                </mat-card>

                              </div>



                            <!--DIV DIREITA-->
                            <!--container ajustado dinamicamente-->
                            <div>


                              <div style="margin-top: 0px; height: 5px; width: 100%; background-color: rgb(180, 180, 180)">&nbsp;</div>

                                <mat-card class="mat-elevation-z8" style="padding: 8px;">

                                    <!--container ajustado dinamicamente-->

                                      <div style="width: 98%; margin-top: 5px; margin-left: 5px;" >
                                        <mat-form-field class="example-full-width">
                                          <mat-label>Buscar na lista </mat-label>
                                          <input matInput (keyup)="applyFilter($event)" placeholder="Digite a busca de qualquer item na lista abaixo..." #input>
                                        </mat-form-field>
                                      </div>


                                      <div id="subDivContainer" style="width: 100%; ">
                                        <div id="subDivAdjustAutoHeightParametro" style="overflow-y: auto; ">

                                          <table mat-table [dataSource]="dataSourceParametro" matSort #sortCabecalho="matSort"
                                              class="mat-elevation-z8" style="width: 98%;  margin-left: 7px; margin-bottom: 3px;  ">




                                              <ng-container matColumnDef="paraNrOrdem">
                                                <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size:12px"> Ordem </th>
                                                <td mat-cell *matCellDef="let element" (click)="setCabecalho(element)" style="width:10%; cursor: pointer;"> {{element.paraNrOrdem}} </td>
                                              </ng-container>


                                              <ng-container matColumnDef="paraDsParametro">
                                                <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size:12px"> Cabeçalho </th>
                                                <td mat-cell *matCellDef="let element" (click)="setCabecalho(element)" style="width:40%; cursor: pointer;"> {{element.paraDsParametro}} </td>
                                              </ng-container>

                                              <ng-container matColumnDef="isPossuiMotivo">
                                                <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size:12px"> &nbsp;</th>
                                                <td mat-cell *matCellDef="let element" (click)="setCabecalho(element)" style="width:25%; font-weight: 600; cursor: pointer;"> {{element.isPossuiMotivo == true ? 'Possui motivo(s) vinculado(s)' : ''}} </td>
                                              </ng-container>

                                              <ng-container matColumnDef="paraInObrigatorio">
                                                <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size:12px"> Obrigatório? </th>
                                                <td mat-cell *matCellDef="let element"  (click)="setCabecalho(element)" style="width:15%; cursor: pointer;"> {{element.paraInObrigatorio=="S" && "Sim" || "Não"}} </td>
                                              </ng-container>

                                              <ng-container matColumnDef="paraDhInativo">
                                                <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size:12px"> Inativo? </th>
                                                <td mat-cell *matCellDef="let element"  (click)="setCabecalho(element)" style="width:10%; cursor: pointer;"> {{element.paraDhInativo && "Sim" || "Não"}} </td>
                                              </ng-container>


                                              <tr mat-header-row *matHeaderRowDef="displayedColumnsCabecalho; sticky: true" style="height: 15px;"></tr>
                                              <tr mat-row *matRowDef="let row; columns: displayedColumnsCabecalho; " [ngClass]="row.isPossuiMotivo === true ? 'aoPassarMouseIsMotivo' : 'aoPassarMouse'" style="height: 10px;"


                                              ></tr>
                                            </table>

                                        </div>

                                    </div>

                                </mat-card>

                              </div>

                            </div>

                          </div>

                        </div>

                    </div>
                  </mat-tab>

                  <!-- Motivo -->
                  <mat-tab *ngFor="let subMenu of [1];let i=index;"  label="📝 Motivo " disabled={{disabledTab}}>

                    <div style="margin-top: 8px;">
                        <!--container ajustado dinamicamente-->
                        <div id="divContainer" style="width: 99%;">

                          <div id="divAdjustAutoHeight" style="overflow-y: hidden;">

                            <div style="margin-left: 5px; margin-right: 5px;">

                            <!--DIV ESQUERDA-->
                            <div>

                              <div style="background-color: rgb(51, 68, 75); height: 30px; width: 100%; color: white; text-align: center; border-radius: 30px 30px 0px 0px;">
                                <div style=" margin-left: 15px; font-size: 14px;">Novo / Editar cadastro</div>
                              </div>
                              <div style="margin-top: 0px; height: 5px; width: 100%; background-color: rgb(180, 180, 180)">&nbsp;</div>


                              <mat-card class="mat-elevation-z8" style="padding: 8px;">


                                  <!--container ajustado dinamicamente-->
                                  <div id="subDivContainer" style="width: 100%; ">
                                      <div id="subDivAdjustAutoHeight" style="overflow-y: auto;">

                                        <!--
                                        <mat-form-field appearance="outline" style="width: 100%; ">
                                            <mat-label style="text-align: left;">
                                              <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                              <b> Formulario</b>
                                              <i>*</i>
                                            </mat-label>
                                            <mat-select formControlName="idFormParametro" style="font-size: 12px; font-weight: 500;">
                                              <mat-option *ngFor="let item of lstBeanFormulario" value="{{item.formIdCdFormulario}}">{{item.formDsFormulario}}</mat-option>
                                            </mat-select>
                                          </mat-form-field>
                                        -->

                                        <div style="width: 100%;">

                                            <mat-card style="padding: 0px; margin-top: 10px; width: 100%; height: 45px; background-color: rgb(255, 240, 242);  cursor: pointer;">
                                              <mat-form-field appearance="outline" style="font-family: 'Poppins-ExtraLight';" >
                                                <mat-label>
                                                <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                                <b>Nome do Motivo</b>
                                                <i>*</i>
                                                </mat-label>
                                                <input matInput formControlName="motiDsMotivo" maxlength="200" onchange="this.value = this.value.toUpperCase()">
                                              </mat-form-field>
                                            </mat-card>
                                        </div>

                                        <div style="width:100%;  text-align: left; margin-top: 18px;">
                                          <table style="width: 100%;">
                                            <tr>
                                              <td style="width: 50%;">

                                                <div style="width: 73%; float: left;">
                                                  <mat-slide-toggle formControlName="motiDhInativo" style="font-size: 12px; ">Cadastro inativo?</mat-slide-toggle>
                                                </div>

                                                <div style="width: 17%; float: left;">
                                                  <button mat-raised-button  type="submit"
                                                    style="background-color: rgb(46, 163, 80); color: #fff; width: 99%;  font-size: 12px;" (click) = "salvarMotivo()">
                                                    {{ this.formulario.controls['motiIdCdMotivo'].value > 0 ? 'Editar' : 'Criar novo' }}
                                                  </button>
                                                </div>
                                                <div style="width: 10%; float: left;">
                                                  <button mat-raised-button color="warn" style="color: #fff; width: 99%; font-size: 12px;"(click) = "cancelarMotivo()">
                                                    Cancelar
                                                  </button>
                                                </div>

                                              </td>
                                            </tr>

                                          </table>
                                        </div>




                                      </div>

                                  </div>

                              </mat-card>

                            </div>



                          <!--DIV DIREITA-->
                          <!--container ajustado dinamicamente-->
                          <div>


                            <div style="margin-top: 0px; height: 5px; width: 100%; background-color: rgb(180, 180, 180)">&nbsp;</div>


                              <mat-card class="mat-elevation-z8" style="padding: 8px;">


                                  <!--container ajustado dinamicamente-->


                                        <div style="width: 98%; margin-top: 5px; margin-left: 5px;" >
                                          <mat-form-field class="example-full-width">
                                            <mat-label>Buscar na lista </mat-label>
                                            <input matInput (keyup)="applyFilter($event)" placeholder="Digite a busca de qualquer item na lista abaixo..." #input>
                                          </mat-form-field>
                                        </div>

                                    <div id="subDivContainer" style="width: 100%; ">
                                      <div id="subDivAdjustAutoHeightMotivo" style="overflow-y: auto; ">

                                        <table mat-table [dataSource]="dataSourceMotivo" matSort #sortCabecalho="matSort"
                                            class="mat-elevation-z8" style="width: 98%;  margin-left: 7px; margin-bottom: 3px;  ">

                                            <ng-container matColumnDef="motiDsMotivo">
                                              <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size:12px"> Motivo </th>
                                              <td mat-cell *matCellDef="let element" (click)="setMotivo(element)" style="width:50%; cursor: pointer;"> {{element.motiDsMotivo}} </td>
                                            </ng-container>


                                            <ng-container matColumnDef="motiDhInativo">
                                              <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size:12px"> Inativo? </th>
                                              <td mat-cell *matCellDef="let element"  (click)="setMotivo(element)" style="width:50%; cursor: pointer;"> {{element.motiDhInativo && "Sim" || "Não"}} </td>
                                            </ng-container>


                                            <tr mat-header-row *matHeaderRowDef="displayedColumnsMotivo; sticky: true" style="height: 15px;"></tr>
                                            <tr mat-row *matRowDef="let row; columns: displayedColumnsMotivo; " class="aoPassarMouse" style="height: 10px;"></tr>
                                          </table>

                                      </div>
                                  </div>
                              </mat-card>

                            </div>

                            </div>

                          </div>

                        </div>

                    </div>

                  </mat-tab>

                  <!-- Cabeçalho X Motivo -->
                  <mat-tab *ngFor="let subMenu of [2];let i=index;"  label="📝 Cabeçalho x Motivo " disabled={{disabledTab}}>

                    <div style="margin-top: 8px;">
                        <!--container ajustado dinamicamente-->
                        <div id="divContainer" style="width: 99%;">

                          <div id="divAdjustAutoHeight" style="overflow-y: hidden;">

                            <div style="margin-left: 5px; margin-right: 5px;">

                              <!--DIV ESQUERDA-->
                              <div>


                                <div style="background-color: rgb(51, 68, 75); height: 30px; width: 100%; color: white; text-align: center; border-radius: 30px 30px 0px 0px;">
                                  <div style=" margin-left: 15px; font-size: 14px;">Novo / Editar cadastro</div>
                                </div>
                                <div style="margin-top: 0px; height: 5px; width: 100%; background-color: rgb(180, 180, 180)">&nbsp;</div>


                                <mat-card class="mat-elevation-z8" style="padding: 8px;">


                                    <!--container ajustado dinamicamente-->
                                    <div id="subDivContainer" style="width: 100%; ">
                                        <div id="subDivAdjustAutoHeight" style="overflow-y: auto;">



                                          <div style="width: 100%;">

                                            <div style="width: 49.5%; float: left;">
                                              <mat-card style="padding: 0px; margin-top: 10px; width: 100%; height: 45px; background-color: rgb(255, 240, 242);  cursor: pointer;">
                                                <mat-form-field appearance="outline" style="width: 100%; ">
                                                  <mat-label style="text-align: left;">
                                                    <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                                    <b> Cabeçalho</b>
                                                    <i>*</i>
                                                  </mat-label>

                                                  <mat-select formControlName="paraIdCdParametroMotivo" style="font-size: 12px; font-weight: 500;" >
                                                    <mat-option *ngFor="let item of lstBeanCmbParametroMot; let i = index"  [hidden]="item.paraDhInativo != null" [value]="item.paraIdCdParametro">{{item.paraDsParametro}}</mat-option>
                                                  </mat-select>

                                                </mat-form-field>
                                              </mat-card>


                                            </div>
                                            <div style="width: 01%; float: left;">
                                              &nbsp;
                                            </div>
                                            <div style="width: 49.5%;  float: left;">
                                              <mat-card style="padding: 0px; margin-top: 10px; width: 100%; height: 45px; background-color: rgb(255, 240, 242);  cursor: pointer;">
                                                <mat-form-field appearance="outline" style="width: 100%; ">
                                                  <mat-label style="text-align: left;">
                                                    <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                                    <b> Motivo</b>
                                                    <i>*</i>
                                                  </mat-label>

                                                  <mat-select formControlName="motiIdCdMotivoMotivo" style="font-size: 12px; font-weight: 500;" >
                                                    <mat-option *ngFor="let item of lstBeanCmbMotivoMot; let i = index"  [hidden]="item.motiDhInativo != null" [value]="item.motiIdCdMotivo">{{item.motiDsMotivo}}</mat-option>
                                                  </mat-select>

                                                </mat-form-field>
                                              </mat-card>
                                            </div>

                                            <br/> <br/> <br/>

                                          </div>




                                            <div style="width:100%;  text-align: left; margin-top: 18px;" *ngIf="this.formulario.controls['mopaIdCdMotivoParametro'].value == ''">
                                              <table style="width: 100%;">
                                                <tr>
                                                  <td style="width: 50%;">

                                                    <div style="width: 73%; float: left;">
                                                      &nbsp;
                                                    </div>

                                                    <div style="width: 17%; float: left;">
                                                      <button mat-raised-button  type="submit" *ngIf="this.formulario.controls['mopaIdCdMotivoParametro'].value == ''"
                                                        style="background-color: rgb(46, 163, 80); color: #fff; width: 99%;  font-size: 12px;" (click) = "salvarCabecalhoXMotivo()">
                                                        {{ this.formulario.controls['mopaIdCdMotivoParametro'].value > 0 ? 'Editar' : 'Criar novo' }}
                                                      </button>
                                                    </div>
                                                    <div style="width: 10%; float: left;">
                                                      <button mat-raised-button color="warn" style="color: #fff; width: 99%; font-size: 12px;"(click) = "cancelarParametroXMotivo()">
                                                        Cancelar
                                                      </button>
                                                    </div>

                                                  </td>
                                                </tr>

                                              </table>
                                            </div>



                                            <div style="width:100%;  text-align: left; margin-top: 18px;" *ngIf="this.formulario.controls['mopaIdCdMotivoParametro'].value != ''">
                                              <table style="width: 100%;">
                                                <tr>
                                                  <td style="width: 50%;">

                                                    <div style="width: 73%; float: left;">
                                                      &nbsp;
                                                    </div>

                                                    <div style="width: 17%; float: left;">
                                                      <button mat-raised-button color="warn" style="color: #fff; width: 99%; font-size: 12px;"(click) = "cancelarParametroXMotivo()">
                                                        Cancelar
                                                      </button>
                                                    </div>
                                                    <div style="width: 10%; float: left;">
                                                      <button mat-raised-button    (click) = "deleteParametroXMotivo(this.formulario.controls['mopaIdCdMotivoParametro'].value)"
                                                          color="warn"  style=" color:rgb(255, 255, 255); width: 99%; font-size: 12px;">
                                                          <mat-icon>delete_forever</mat-icon> Excluir
                                                      </button>
                                                    </div>

                                                  </td>
                                                </tr>

                                              </table>
                                            </div>



                                        </div>

                                    </div>

                                </mat-card>

                              </div>



                              <!--DIV DIREITA-->
                              <!--container ajustado dinamicamente-->
                              <div>


                                <div style="margin-top: 0px; height: 5px; width: 100%; background-color: rgb(180, 180, 180)">&nbsp;</div>


                                  <mat-card class="mat-elevation-z8" style="padding: 8px;">


                                      <!--container ajustado dinamicamente-->


                                            <div style="width: 98%; margin-top: 5px; margin-left: 5px;" >
                                              <mat-form-field class="example-full-width">
                                                <mat-label>Buscar na lista </mat-label>
                                                <input matInput (keyup)="applyFilter($event)" placeholder="Digite a busca de qualquer item na lista abaixo..." #input>
                                              </mat-form-field>
                                            </div>

                                        <div id="subDivContainer" style="width: 100%; ">
                                          <div id="subDivAdjustAutoHeightCabecalhoXMotivo" style="overflow-y: auto; ">

                                            <table mat-table [dataSource]="dataSourceParametroXMotivo" matSort #sortCabecalho="matSort"
                                            class="mat-elevation-z8" style="width: 98%;  margin-left: 7px; margin-bottom: 3px;  ">

                                            <ng-container matColumnDef="paraIdCdParametro">
                                              <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size:12px"> Cabeçalho </th>
                                              <td mat-cell *matCellDef="let element" (click)="setParametroXMotivo(element)" style="width:50%; cursor: pointer;"> {{element.parameter.paraDsParametro}} </td>
                                            </ng-container>

                                            <ng-container matColumnDef="motiIdCdMotivo">
                                              <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size:12px"> Motivo </th>
                                              <td mat-cell *matCellDef="let element" (click)="setParametroXMotivo(element)" style="width:50%; cursor: pointer;"> {{element.motive.motiDsMotivo}} </td>
                                            </ng-container>


                                            <tr mat-header-row *matHeaderRowDef="displayedColumnsParametrosXMotivo; sticky: true" style="height: 15px;"></tr>
                                            <tr mat-row *matRowDef="let row; columns: displayedColumnsParametrosXMotivo; " class="aoPassarMouse" style="height: 10px;"></tr>
                                          </table>


                                          </div>
                                      </div>
                                  </mat-card>

                                </div>

                              </div>

                          </div>

                        </div>

                    </div>


                  </mat-tab>

                </mat-tab-group>

              </mat-tab>

              <!-- Grupo Categoria -->
              <mat-tab *ngFor="let subMenu of [2];let i=index;"  label="📝 Grupo Categoria " disabled={{disabledTab}}>
                    <div style="margin-top: 8px;">
                        <!--container ajustado dinamicamente-->
                        <div id="divContainer" style="width: 99%;">

                          <div id="divAdjustAutoHeight" style="overflow-y: hidden;">

                            <div style="margin-left: 5px; margin-right: 5px;">

                            <!--DIV ESQUERDA-->
                            <!--<div id="formAndList">-->
                            <div>
                              <div style="background-color: rgb(51, 68, 75); height: 30px; width: 100%; color: white; text-align: center; border-radius: 30px 30px 0px 0px;">
                                <div style=" margin-left: 15px; font-size: 14px;">Novo / Editar cadastro</div>
                              </div>
                              <div style="margin-top: 0px; height: 5px; width: 100%; background-color: rgb(180, 180, 180)">&nbsp;</div>

                              <mat-card class="mat-elevation-z8" style="padding: 8px;">

                                  <!--container ajustado dinamicamente-->
                                  <div id="subDivContainer" style="width: 100%; ">
                                      <div id="subDivAdjustAutoHeight" style="overflow-y: auto;">

                                        <!--
                                          <mat-form-field appearance="outline" style="width: 100%; ">
                                            <mat-label style="text-align: left;">
                                              <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                              <b> Formulario</b>
                                              <i>*</i>
                                            </mat-label>

                                            <mat-select style="font-size: 12px; font-weight: 500;">
                                              <mat-option formControlName="idFormGpCategoria" *ngFor="let item of lstBeanFormulario" value="{{item.formIdCdFormulario}}">{{item.formDsFormulario}}</mat-option>
                                            </mat-select>
                                          </mat-form-field>
                                        -->




                                        <div style="width: 100%;">

                                          <div style="width: 12%; float: left;">
                                            <mat-form-field appearance="outline" style="width: 100%; font-family: 'Poppins-ExtraLight'; font-size: 12px;" >
                                              <mat-label>
                                                <b>Ordem**</b>
                                              </mat-label>
                                              <input matInput type="number" formControlName="grcaNrOrdem" style="font-weight: bold;" onchange="this.value = this.value.toUpperCase()">
                                            </mat-form-field>
                                          </div>
                                          <div style="width: 01%; float: left;">
                                            &nbsp;
                                          </div>
                                          <div style="width: 87%;  float: left;">
                                            <mat-card style="padding: 0px; margin-top: 10px; width: 100%; height: 45px; background-color: rgb(255, 240, 242);  cursor: pointer;">
                                              <mat-form-field appearance="outline" style="width: 100%; font-family: 'Poppins-ExtraLight'; font-size: 12px;" >
                                                <mat-label>
                                                  <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                                  <b> Nome do Grupo das Categorias** </b>

                                                </mat-label>
                                                <input matInput formControlName="grcaDsGrupoCategoria" style="font-weight: bold;" maxlength="200" onchange="this.value = this.value.toUpperCase()">
                                              </mat-form-field>
                                            </mat-card>
                                          </div>

                                          <br/> <br/> <br/>

                                        </div>



                                        <div style="width:100%;  text-align: left; margin-top: 18px;">
                                          <table style="width: 100%;">
                                            <tr>
                                              <td style="width: 50%;">
                                                <div style="width: 13%; float: left;">
                                                  &nbsp;
                                                </div>
                                                <div style="width: 20%; float: left;">
                                                  <mat-slide-toggle formControlName="grcaDhInativo" style="font-size: 12px; ">Cadastro inativo?</mat-slide-toggle>
                                                </div>
                                                <div style="width: 40%;  float: left;">
                                                  <mat-checkbox formControlName="grcaInMapeamento" style="width: 20px;" >
                                                    Mapeamento <i>(Relatórios)</i>
                                                  </mat-checkbox>
                                                </div>
                                                <div style="width: 17%; float: left;">
                                                  <button mat-raised-button  type="submit"
                                                    style="background-color: rgb(46, 163, 80); color: #fff; width: 99%;  font-size: 12px" (click) = "salvarGrupo();">
                                                    {{ this.formulario.controls['idGrupoCategoria'].value > 0 ? 'Editar' : 'Criar novo' }}
                                                  </button>
                                                </div>
                                                <div style="width: 10%; float: left;">
                                                  <button mat-raised-button color="warn" style="color: #fff; width: 99%; font-size: 12px;" (click) = "cancelarGpCategoria()">
                                                    Cancelar
                                                  </button>
                                                </div>

                                              </td>
                                            </tr>

                                          </table>
                                        </div>


                                      </div>

                                  </div>

                              </mat-card>

                            </div>



                          <!--DIV DIREITA-->
                          <!--container ajustado dinamicamente-->
                          <!--<div id="formAndList" style="margin-left: 10px;">-->
                          <div>

                              <div style="margin-top: 0px; height: 5px; width: 100%; background-color: rgb(180, 180, 180)">&nbsp;</div>

                              <mat-card class="mat-elevation-z8" style="padding: 8px;">

                                  <!--container ajustado dinamicamente-->
                                    <div style="width: 98%; margin-left: 5px;" >
                                      <mat-form-field class="example-full-width">
                                        <mat-label>Buscar na lista </mat-label>
                                        <input matInput (keyup)="applyFilter($event)" placeholder="Digite a busca de qualquer item na lista abaixo..." #input>
                                      </mat-form-field>
                                    </div>

                                    <div id="subDivContainer" style="width: 100%; ">
                                      <div id="subDivAdjustAutoHeight" style="overflow-y: auto; ">

                                        <table mat-table [dataSource]="dataSourceGrupoCategoria" matSort #sortGpCategoria="matSort"
                                            class="mat-elevation-z8" style="width: 98%;  margin-left: 7px; margin-bottom: 3px;  ">

                                            <!-- Position Column -->
                                            <ng-container matColumnDef="grcaNrOrdem">
                                              <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size:12px"> Ordem </th>
                                              <td mat-cell *matCellDef="let element" (click)="setGpCategoria(element)" style="width:10%; cursor: pointer;"> {{element.grcaNrOrdem}} </td>
                                            </ng-container>

                                            <!-- Position Column -->
                                            <ng-container matColumnDef="grcaDsGrupoCategoria">
                                              <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size:12px"> Nome do Grupo de Categorias </th>
                                              <td mat-cell *matCellDef="let element" (click)="setGpCategoria(element)" style="width:80%; cursor: pointer;"> {{element.grcaDsGrupoCategoria}} </td>
                                            </ng-container>

                                            <!-- Symbol Column -->
                                            <ng-container matColumnDef="grcaDhInativo">
                                              <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size:12px"> Inativo? </th>
                                              <td mat-cell *matCellDef="let element" (click)="setGpCategoria(element)" style="width:10%; cursor: pointer;"> {{element.grcaDhInativo && "Sim" || "Não"}} </td>
                                            </ng-container>


                                            <tr mat-header-row *matHeaderRowDef="displayedColumnsGrupoDeCategorias; sticky: true" style="height: 15px;"></tr>
                                            <tr mat-row *matRowDef="let row; columns: displayedColumnsGrupoDeCategorias; " class="aoPassarMouse" style="height: 10px;"></tr>
                                          </table>

                                      </div>
                                  </div>
                              </mat-card>

                            </div>

                            </div>

                          </div>

                        </div>

                    </div>
              </mat-tab>

              <!-- Categoria -->
              <mat-tab *ngFor="let subMenu of [3];let i=index;"  label="📝 Categoria " disabled={{disabledTab}}>

                    <div style="margin-top: 8px;">
                        <!--container ajustado dinamicamente-->
                        <div id="divContainer" style="width: 99%;">

                          <div id="divAdjustAutoHeight" style="overflow-y: hidden;">

                            <div style="margin-left: 5px; margin-right: 5px;">

                            <!--DIV ESQUERDA-->
                            <div>


                              <div style="background-color: rgb(51, 68, 75); height: 30px; width: 100%; color: white; text-align: center; border-radius: 30px 30px 0px 0px;" >
                                <div style=" margin-left: 15px; font-size: 14px;">Novo / Editar cadastro</div>
                              </div>
                              <div style="margin-top: 0px; height: 5px; width: 100%; background-color: rgb(180, 180, 180)">&nbsp;</div>


                              <mat-card class="mat-elevation-z8" style="padding: 8px;">


                                  <!--container ajustado dinamicamente-->
                                  <div id="subDivContainer" style="width: 100%; ">
                                      <div id="subDivAdjustAutoHeight" style="overflow-y: auto;">



                                        <div style="width: 100%;">

                                          <div style="width: 36%; float: left;">
                                            <mat-form-field appearance="outline" style="width: 100%; ">
                                              <mat-label style="text-align: left;">
                                                <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                                <b> Grupo de categoria</b>
                                                <i>*</i>
                                              </mat-label>
                                              <mat-select formControlName="idGrcaCategoria" style="font-size: 12px; font-weight: 500;">
                                                <mat-option *ngFor="let item of lstBeanCategoryGroup; let i = index" [hidden]="item.grcaDhInativo != null" [value]="item.grcaIdCdGrupoCategoria">{{item.grcaDsGrupoCategoria}}</mat-option>
                                              </mat-select>
                                            </mat-form-field>
                                          </div>
                                          <div style="width: 01%; float: left;">
                                            &nbsp;
                                          </div>
                                          <div style="width: 12%; float: left;">
                                            <mat-form-field appearance="outline" style="width: 100%; font-family: 'Poppins-ExtraLight'; font-size: 12px;" >
                                              <mat-label>
                                                <b>Ordem**</b>
                                              </mat-label>
                                              <input matInput type="number" formControlName="cateNrOrdem" style="font-weight: bold;" onchange="this.value = this.value.toUpperCase()">
                                            </mat-form-field>
                                          </div>
                                          <div style="width: 01%; float: left;">
                                            &nbsp;
                                          </div>
                                          <div style="width: 50%;  float: left;">
                                            <mat-card style="padding: 0px; margin-top: 10px; width: 100%; height: 45px; background-color: rgb(255, 240, 242);  cursor: pointer;">
                                              <mat-form-field appearance="outline" style="width: 100%; font-family: 'Poppins-ExtraLight'; font-size: 12px;" >
                                                <mat-label>
                                                  <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                                  <b> Nome da Categoria**</b>
                                                </mat-label>
                                                <input matInput formControlName="cateDsCategoria" style="font-weight: bold;" maxlength="200" onchange="this.value = this.value.toUpperCase()">
                                              </mat-form-field>
                                            </mat-card>
                                          </div>
                                          <br/> <br/> <br/>
                                        </div>


                                        <div style="width:100%;  text-align: left; margin-top: 18px;">
                                          <div style="width: 15%; float: left;">
                                                <mat-slide-toggle formControlName="cateDhInativo" style="font-size: 12px; ">Cadastro inativo?</mat-slide-toggle>
                                          </div>
                                          <div style="width: 60%; float: left;">
                                                &nbsp;
                                          </div>
                                          <div style="width: 25%;  float: left;">
                                                <div style="width: 60%; float: left;">
                                                  <button mat-raised-button  type="submit"
                                                    style="background-color: rgb(46, 163, 80); color: #fff; width: 99%;  font-size: 12px" (click) = "salvarCategoria()">
                                                    {{ this.formulario.controls['idCategoria'].value > 0 ? 'Editar' : 'Criar novo' }}
                                                  </button>
                                                </div>
                                                <div style="width: 40%; float: left;">
                                                  <button mat-raised-button color="warn" style="color: #fff; width: 99%; font-size: 12px;" (click) = "cancelarCategoria()">
                                                    Cancelar
                                                  </button>
                                                </div>
                                          </div>
                                        </div>




                                      </div>

                                  </div>

                              </mat-card>

                            </div>



                          <!--DIV DIREITA-->
                          <!--container ajustado dinamicamente-->
                          <div>

                            <div style="margin-top: 0px; height: 5px; width: 100%; background-color: rgb(180, 180, 180)">&nbsp;</div>

                              <mat-card class="mat-elevation-z8" style="padding: 8px;">

                                    <!--container ajustado dinamicamente-->
                                    <div style="width: 98%; margin-top: 0px; margin-left: 5px;" >
                                      <mat-form-field class="example-full-width">
                                        <mat-label>Buscar na lista </mat-label>
                                        <input matInput (keyup)="applyFilter($event)" placeholder="Digite a busca de qualquer item na lista abaixo..." #input>
                                      </mat-form-field>
                                    </div>

                                    <div id="subDivContainer" style="width: 100%; ">
                                      <div id="subDivAdjustAutoHeight" style="overflow-y: auto; ">

                                        <table mat-table [dataSource]="dataSourceCategoria" matSort #sortCategoria="matSort"
                                            class="mat-elevation-z8" style="width: 98%;  margin-left: 7px; margin-bottom: 3px;  ">



                                            <ng-container matColumnDef="grcaDsGrupoCategoria">
                                              <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size:12px"> Grupo </th>
                                              <td mat-cell *matCellDef="let element" (click)="setCategoria(element)" style="width:40%; cursor: pointer;"> {{element.grcaDsGrupoCategoria}} </td>
                                            </ng-container>

                                             <ng-container matColumnDef="cateNrOrdem">
                                              <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size:12px"> Ordem </th>
                                              <td mat-cell *matCellDef="let element" (click)="setCategoria(element)" style="width:10%; cursor: pointer;"> {{element.cateNrOrdem}} </td>
                                            </ng-container>

                                            <ng-container matColumnDef="cateDsCategoria">
                                              <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size:12px"> Nome da Categoria </th>
                                              <td mat-cell *matCellDef="let element" (click)="setCategoria(element)" style="width:40%; cursor: pointer;"> {{element.cateDsCategoria}} </td>
                                            </ng-container>

                                            <ng-container matColumnDef="cateDhInativo">
                                              <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size:12px"> Inativo? </th>
                                              <td mat-cell *matCellDef="let element"  (click)="setCategoria(element)" style="width:10%; cursor: pointer;"> {{element.cateDhInativo && "Sim" || "Não"}} </td>
                                            </ng-container>

                                            <tr mat-header-row *matHeaderRowDef="displayedColumnsCategorias; sticky: true" style="height: 15px;"></tr>
                                            <tr mat-row *matRowDef="let row; columns: displayedColumnsCategorias; " class="aoPassarMouse" style="height: 10px;"></tr>
                                          </table>

                                      </div>
                                  </div>
                              </mat-card>

                            </div>

                            </div>

                          </div>

                        </div>

                    </div>

              </mat-tab>

              <!-- Perguntas -->
              <mat-tab *ngFor="let subMenu of [4];let i=index;"  label="📝 Perguntas " disabled={{disabledTab}}>

                    <div style="margin-top: 8px;">
                        <!--container ajustado dinamicamente-->
                        <div id="divContainer" style="width: 99%;">

                          <div id="divAdjustAutoHeight" style="overflow-y: hidden;">

                            <div style="margin-left: 5px; margin-right: 5px;">

                            <!--DIV ESQUERDA-->
                              <div>

                                <div style="background-color: rgb(51, 68, 75); height: 30px; width: 100%; color: white; text-align: center; border-radius: 30px 30px 0px 0px;">
                                  <div style=" margin-left: 15px; font-size: 14px;">Novo / Editar cadastro</div>
                                </div>
                                <div style="margin-top: 0px; height: 5px; width: 100%; background-color: rgb(180, 180, 180)">&nbsp;</div>


                                <mat-card class="mat-elevation-z8" style="padding: 8px; height: 220px;">


                                    <div style="width: 100%;">

                                              <div style="width: 49%; float: left;">
                                                <mat-form-field appearance="outline" style="width: 100%; ">
                                                  <mat-label style="text-align: left;">
                                                    <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                                    <b> Grupo de categoria</b>
                                                    <i>*</i>
                                                  </mat-label>
                                                  <mat-select formControlName="idGrupoCategoriaPergunta" style="font-size: 12px; font-weight: 500;" (selectionChange) ="listaCategoriaPergunta($event)">
                                                    <mat-option *ngFor="let item of lstBeanCategoryGroup; let i = index"  [hidden]="item.grcaDhInativo != null" [value]="item.grcaIdCdGrupoCategoria">{{item.grcaDsGrupoCategoria}}</mat-option>
                                                  </mat-select>
                                                </mat-form-field>
                                              </div>
                                              <div style="width: 01%; float: left;">
                                                &nbsp;
                                              </div>
                                              <div style="width: 50%; float: left;">
                                                <mat-form-field appearance="outline" style="width: 100%; ">
                                                  <mat-label style="text-align: left;">
                                                    <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                                    <b> Categoria</b>
                                                    <i>*</i>
                                                  </mat-label>
                                                  <mat-select formControlName="idCategoriaPergunta" style="font-size: 12px; font-weight: 500;">
                                                    <mat-option *ngFor="let item of lstBeanCategory; let i = index"  [hidden]="item.cateDhInativo != null" [value]="item.cateIdCdCategoria">{{item.cateDsCategoria}}</mat-option>
                                                  </mat-select>
                                                </mat-form-field>
                                              </div>

                                      <br/><br/><br/>


                                              <div style="width: 15%; float: left;">
                                                <mat-form-field appearance="outline" style="width: 100%; font-family: 'Poppins-ExtraLight'; font-size: 12px;" >
                                                  <mat-label>
                                                    <b>Ordem**</b>
                                                  </mat-label>
                                                  <input matInput type="number" formControlName="pergNrOrdem" style="font-weight: bold;" onchange="this.value = this.value.toUpperCase()">
                                                </mat-form-field>
                                              </div>
                                              <div style="width: 01%; float: left;">
                                                &nbsp;
                                              </div>

                                              <div style="width: 59%;  float: left;">
                                                <mat-card style="padding: 0px; margin-top: 10px; width: 100%; height: 45px; background-color: rgb(255, 240, 242);  cursor: pointer;">
                                                  <mat-form-field appearance="outline" style="width: 100%; font-family: 'Poppins-ExtraLight'; font-size: 12px;" >
                                                    <mat-label>
                                                      <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                                      <b> Pergunta**</b>
                                                    </mat-label>
                                                    <input matInput formControlName="pergDsPergunta"  style="font-weight: bold; width: 100%;" maxlength="600" onchange="this.value = this.value.toUpperCase()">
                                                  </mat-form-field>
                                                </mat-card>
                                              </div>

                                              <div style="width: 1%; float: left;">&nbsp;
                                              </div>

                                              <div style="width: 24%;  float: left; margin-top: 10px;">
                                            
                                                  <mat-slide-toggle formControlName="pergInExtra" style="font-size: 12px; "  *ngIf="this.formulario.controls['formDsTipoPontuacao'].value == 'MEDIA'" 
                                                              matTooltipPosition="right" matTooltip="Perguntas trunfo não entram na pontuação média. Mas será adicionada como pontuação extra somada ao cauculo da média.">
                                                    Pergunta Trunfo
                                                  </mat-slide-toggle>
                                                
                                              </div>

                                      <br/> <br/> <br/>


                                          <div style="width: 100%;">

                                            <div style="width:100%;  text-align: left; margin-top: 18px;">
                                              <div style="width: 15%; float: left;">
                                                    <mat-slide-toggle formControlName="pergInRespostasemlista" style="font-size: 12px; ">Respostas em lista?</mat-slide-toggle>
                                              <br/>&nbsp;<br/>
                                                    <mat-slide-toggle formControlName="pergDhInativo" style="font-size: 12px; ">Cadastro inativo?</mat-slide-toggle>
                                              </div>
                                              <div style="width: 1%; float: left;">&nbsp;
                                                </div>
                                              <div style="width: 59%; float: left;">
                                                <mat-form-field appearance="outline" style="font-family: 'Poppins-ExtraLight'; font-size: 12px; margin-top: -4px;" >
                                                  <mat-label>
                                                    <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                                    <b> Descrição</b>
                                                    <i>*</i>
                                                  </mat-label>
                                                  <textarea matInput placeholder="Descrição" rows="3" style="white-space: pre-line;" formControlName="descricaoPergunta" onchange="this.value = this.value.toUpperCase()"></textarea>
                                                </mat-form-field>
                                              </div>
                                              <div style="width: 25%;  float: left;">
                                                    <div style="width: 59%; float: left;">
                                                      <button mat-raised-button  type="submit"
                                                        style="background-color: rgb(46, 163, 80); color: #fff; width: 99%;  font-size: 12px" (click) = "salvarPerguntas()">
                                                        {{ this.formulario.controls['idPergunta'].value > 0 ? 'Editar' : 'Criar novo' }}
                                                      </button>
                                                    </div>
                                                    <div style="width: 1%; float: left;">&nbsp;
                                                    </div>
                                                    <div style="width: 40%; float: left;">
                                                      <button mat-raised-button color="warn" style="color: #fff; width: 99%; font-size: 12px;" (click) = "cancelarPerguntas()">
                                                        Cancelar
                                                      </button>
                                                    </div>
                                              </div>
                                            </div>


                                          </div>

                                    </div>


                                </mat-card>

                              </div>

                          <!--DIV DIREITA-->
                          <!--container ajustado dinamicamente-->
                          <div>


                            <div style="margin-top: 0px; height: 5px; width: 100%; background-color: rgb(180, 180, 180)">&nbsp;</div>


                              <mat-card class="mat-elevation-z8" style="padding: 8px;">


                                  <!--container ajustado dinamicamente-->


                                    <div style="width: 100%; margin-top: 5px; margin-left: 5px;" >
                                      <mat-form-field class="example-full-width">
                                        <mat-label>Buscar na lista </mat-label>
                                        <input matInput (keyup)="applyFilter($event)" placeholder="Digite a busca de qualquer item na lista abaixo..." #input>
                                      </mat-form-field>
                                    </div>

                                    <div id="subDivContainer" style="width: 100%; ">
                                      <div id="subDivAdjustAutoHeightPergunta" style="overflow-y: auto; overflow-x: hidden;">

                                        <table mat-table [dataSource]="dataSourcePergunta" matSort #sortPergunta="matSort"
                                            class="mat-elevation-z8" style="width: 98%;  margin-left: 7px; margin-bottom: 3px;  ">

                                            <ng-container matColumnDef="grcaDsGrupoCategoria">
                                              <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size:12px"> Grupo </th>
                                              <td mat-cell *matCellDef="let element" (click)="setPerguntas(element)" style="width:28%; cursor: pointer;"> {{element.grcaDsGrupoCategoria}} </td>
                                            </ng-container>

                                            <ng-container matColumnDef="cateDsCategoria">
                                              <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size:12px"> Categoria </th>
                                              <td mat-cell *matCellDef="let element" (click)="setPerguntas(element)" style="width:22%; cursor: pointer;"> {{element.cateDsCategoria}} </td>
                                            </ng-container>

                                            <ng-container matColumnDef="pergNrOrdem">
                                              <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size:12px"> Ordem </th>
                                              <td mat-cell *matCellDef="let element" (click)="setPerguntas(element)" style="width:10%; cursor: pointer;"> {{element.pergNrOrdem}} </td>
                                            </ng-container>

                                            <ng-container matColumnDef="pergDsPergunta">
                                              <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size:12px"> Pergunta </th>
                                              <td mat-cell *matCellDef="let element" (click)="setPerguntas(element)" style="width:30%; cursor: pointer;"> {{element.pergDsPergunta}} </td>
                                            </ng-container>

                                            <ng-container matColumnDef="pergDhInativo">
                                              <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size:12px"> Inativo? </th>
                                              <td mat-cell *matCellDef="let element"  (click)="setPerguntas(element)" style="width:10%; cursor: pointer;"> {{element.pergDhInativo && "Sim" || "Não"}} </td>
                                            </ng-container>


                                            <tr mat-header-row *matHeaderRowDef="displayedColumnsPerguntas; sticky: true" style="height: 15px;"></tr>
                                            <tr mat-row *matRowDef="let row; columns: displayedColumnsPerguntas; " class="aoPassarMouse" style="height: 10px;"></tr>
                                          </table>

                                      </div>
                                  </div>
                              </mat-card>

                            </div>

                            </div>

                          </div>

                        </div>

                    </div>

              </mat-tab>

              <!-- Respostas -->
              <mat-tab *ngFor="let subMenu of [5];let i=index;"  label="📝 Respostas " disabled={{disabledTab}}>
                    <div style="margin-top: 8px;">
                        <!--container ajustado dinamicamente-->
                        <div id="divContainer" style="width: 99%;">

                          <div id="divAdjustAutoHeight" style="overflow-y: hidden;">

                            <div style="margin-left: 5px; margin-right: 5px;">

                            <!--DIV ESQUERDA-->
                            <div>

                              <div style="background-color: rgb(51, 68, 75); height: 30px; width: 100%; color: white; text-align: center; border-radius: 30px 30px 0px 0px;">
                                <div style=" margin-left: 15px; font-size: 14px;">Novo / Editar cadastro</div>
                              </div>
                              <div style="margin-top: 0px; height: 5px; width: 100%; background-color: rgb(180, 180, 180)">&nbsp;</div>


                              <mat-card class="mat-elevation-z8" style="padding: 8px;">

                                  <!--container ajustado dinamicamente-->
                                  <div id="subDivContainer" style="width: 100%; ">
                                      <div id="subDivAdjustAutoHeight" style="overflow-y: auto;">

                                          <!--
                                        <mat-form-field appearance="outline" style="width: 100%; ">
                                          <mat-label style="text-align: left;">
                                            <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                            <b> Pergunta</b>
                                            <i>*</i>
                                          </mat-label>
                                          <mat-select formControlName="idPergResposta" style="font-size: 12px; font-weight: 500;">
                                            <mat-option *ngFor="let item of lstBeanQuestion" [value]="item.pergIdCdPergunta">{{item.pergDsPergunta}}</mat-option>
                                          </mat-select>

                                        </mat-form-field>
                                        -->



                                          <div style="width: 100%;">

                                            <div style="width: 12%; float: left;">
                                              <mat-form-field appearance="outline" style="width: 100%; font-family: 'Poppins-ExtraLight'; font-size: 12px;" >
                                                <mat-label>
                                                  <b>Ordem**</b>
                                                </mat-label>
                                                <input matInput type="number" formControlName="respNrOrdem"  style="font-weight: bold;" onchange="this.value = this.value.toUpperCase()">
                                              </mat-form-field>
                                            </div>
                                            <div style="width: 01%; float: left;">
                                              &nbsp;
                                            </div>
                                            <div style="width: 87%;  float: left;">
                                              <mat-card style="padding: 0px; margin-top: 10px; width: 100%; height: 45px; background-color: rgb(255, 240, 242);  cursor: pointer;">
                                                <mat-form-field appearance="outline" style="width: 100%; font-family: 'Poppins-ExtraLight'; font-size: 12px;" >
                                                  <mat-label>
                                                    <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                                    <b> Resposta**</b>
                                                  </mat-label>
                                                  <input matInput formControlName="respDsResposta" style="font-weight: bold;" maxlength="200" onchange="this.value = this.value.toUpperCase()">
                                                </mat-form-field>
                                              </mat-card>
                                            </div>
                                            <br/> <br/> <br/>

                                          </div>


                                          <div style="width:100%;  text-align: left; margin-top: 18px;">
                                            <table style="width: 100%;">
                                              <tr>
                                                <td style="width: 50%;">
                                                  <div style="width: 13%; float: left;">
                                                    &nbsp;
                                                  </div>
                                                  <div style="width: 20%; float: left;">
                                                    <mat-slide-toggle formControlName="respDhInativo" style="font-size: 12px; ">Cadastro inativo?</mat-slide-toggle>
                                                  </div>
                                                  <div style="width: 40%;  float: left; text-align: center;">
                                                    <mat-slide-toggle formControlName="respInNaoseaplica" style="font-size: 12px; ">Não aplicável (ao cálculo de média)</mat-slide-toggle>
                                                  </div>
                                                  <div style="width: 17%; float: left;">
                                                    <button mat-raised-button  type="submit"
                                                      style="background-color: rgb(46, 163, 80); color: #fff; width: 99%;  font-size: 12px" (click) = "salvarRespostas()">
                                                      {{ this.formulario.controls['idResposta'].value > 0 ? 'Editar' : 'Criar novo' }}
                                                    </button>
                                                  </div>
                                                  <div style="width: 10%; float: left;">
                                                    <button mat-raised-button color="warn" style="color: #fff; width: 99%; font-size: 12px;" (click) = "cancelarRespostas()">
                                                      Cancelar
                                                    </button>
                                                  </div>

                                                </td>
                                              </tr>

                                            </table>
                                          </div>



                                      </div>

                                  </div>

                              </mat-card>

                            </div>



                          <!--DIV DIREITA-->
                          <!--container ajustado dinamicamente-->
                          <div>


                              <div style="margin-top: 0px; height: 5px; width: 100%; background-color: rgb(180, 180, 180)">&nbsp;</div>

                              <mat-card class="mat-elevation-z8" style="padding: 8px;">

                                  <!--container ajustado dinamicamente-->


                                        <div style="width: 98%; margin-top: 5px; margin-left: 5px;" >
                                          <mat-form-field class="example-full-width">
                                            <mat-label>Buscar na lista </mat-label>
                                            <input matInput (keyup)="applyFilter($event)" placeholder="Digite a busca de qualquer item na lista abaixo..." #input>
                                          </mat-form-field>
                                        </div>

                                    <div id="subDivContainer" style="width: 100%; ">
                                      <div id="subDivAdjustAutoHeight" style="overflow-y: auto; ">

                                        <table mat-table [dataSource]="dataSourceResposta" matSort #sortResposta="matSort"
                                            class="mat-elevation-z8" style="width: 98%;  margin-left: 7px; margin-bottom: 3px;  ">

                                            <ng-container matColumnDef="respNrOrdem">
                                              <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size:12px"> Ordem </th>
                                              <td mat-cell *matCellDef="let element" (click)="setRespostas(element)" style="width:10%; cursor: pointer;"> {{element.respNrOrdem}} </td>
                                            </ng-container>

                                            <ng-container matColumnDef="respDsResposta">
                                              <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size:12px"> Resposta </th>
                                              <td mat-cell *matCellDef="let element" (click)="setRespostas(element)" style="width:60%; cursor: pointer;"> {{element.respDsResposta}} </td>
                                            </ng-container>

                                            <ng-container matColumnDef="respInNaoseaplica">
                                              <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size:12px"> Não aplicável na média </th>
                                              <td mat-cell *matCellDef="let element"  (click)="setRespostas(element)" style="width:20%; cursor: pointer;">{{element.respInNaoseaplica == 'S' ? "Sim" : "Não"}} </td>
                                            </ng-container>

                                            <ng-container matColumnDef="respDhInativo">
                                              <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size:12px"> Inativo? </th>
                                              <td mat-cell *matCellDef="let element"  (click)="setRespostas(element)" style="width:10%; cursor: pointer;"> {{element.respDhInativo && "Sim" || "Não"}} </td>
                                            </ng-container>


                                            <tr mat-header-row *matHeaderRowDef="displayedColumnsRespostas; sticky: true" style="height: 15px;"></tr>
                                            <tr mat-row *matRowDef="let row; columns: displayedColumnsRespostas; " class="aoPassarMouse" style="height: 10px;"></tr>
                                          </table>

                                      </div>
                                  </div>
                              </mat-card>

                            </div>

                            </div>

                          </div>

                        </div>

                    </div>
              </mat-tab>

              <!-- Pergunta X Resposta -->
              <mat-tab *ngFor="let subMenu of [6];let i=index;"  label="📝 Pergunta X Resposta " disabled={{disabledTab}}>
                  <div style="margin-top: 8px;">
                      <!--container ajustado dinamicamente-->
                      <div id="divContainer" style="width: 99%;">
                        <div id="divAdjustAutoHeight" style="overflow-y: hidden;">
                          <div style="margin-left: 5px; margin-right: 5px;">


                            <!--DIV ESQUERDA-->
                          <div>
                            <div style="background-color: rgb(51, 68, 75); height: 30px; width: 100%; color: white; text-align: center; border-radius: 30px 30px 0px 0px;">
                              <div style=" margin-left: 15px; font-size: 14px;">Novo / Editar cadastro</div>
                            </div>
                            <div style="margin-top: 0px; height: 5px; width: 100%; background-color: rgb(180, 180, 180)">&nbsp;</div>
                            <mat-card class="mat-elevation-z8" style="padding: 8px;">
                                <!--container ajustado dinamicamente-->


                                      <div style="width: 100%;">
                                        <div style="width: 49.5%; float: left;">
                                          <mat-form-field appearance="outline" style="width: 100%; ">
                                            <mat-label style="text-align: left;">
                                              <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                              <b> Grupo de categoria</b>
                                              <i>*</i>
                                            </mat-label>
                                            <mat-select formControlName="idGrupoCategoriaPergXResp" style="font-size: 12px; font-weight: 500;" (selectionChange) ="listaCategoriaPergunta($event)">
                                              <mat-option *ngFor="let item of lstBeanCategoryGroup; let i = index"  [hidden]="item.grcaDhInativo != null" [value]="item.grcaIdCdGrupoCategoria">{{item.grcaDsGrupoCategoria}}</mat-option>
                                            </mat-select>
                                          </mat-form-field>
                                        </div>
                                        <div style="width: 1%; float: left;">
                                          &nbsp;
                                        </div>
                                        <div style="width: 49.5%; float: left;">
                                          <mat-form-field appearance="outline" style="width: 100%; ">
                                            <mat-label style="text-align: left;">
                                              <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                              <b> Categoria</b>
                                              <i>*</i>
                                            </mat-label>
                                            <mat-select formControlName="idCategoriaPergXRespa" style="font-size: 12px; font-weight: 500;" (selectionChange) ="listaPerguntaCategoria($event)">
                                              <mat-option *ngFor="let item of lstBeanCategory; let i = index"  [hidden]="item.cateDhInativo != null" [value]="item.cateIdCdCategoria">{{item.cateDsCategoria}}</mat-option>
                                            </mat-select>
                                          </mat-form-field>
                                        </div>
                                      </div>
                                      <div style="width: 100%;">
                                        <div style="width: 47.5%; float: left;">
                                          <mat-card style="padding: 0px; margin-top: 10px; width: 100%; height: 45px; background-color: rgb(255, 240, 242);  cursor: pointer;">
                                            <mat-form-field appearance="outline" style="width: 100%; ">
                                              <mat-label style="text-align: left;">
                                                <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                                <b> Pergunta</b>
                                                <i>*</i>
                                              </mat-label>
                                              <mat-select formControlName="pergDsPergunta" style="font-size: 12px; font-weight: 500;"  (selectionChange) ="changePerg($event)">
                                                <mat-option *ngFor="let item of lstBeanQuestion; let i = index"  [hidden]="item.pergDhInativo != null" [value]="item.pergIdCdPergunta">{{item.pergDsPergunta}}</mat-option>
                                              </mat-select>
                                            </mat-form-field>
                                          </mat-card>
                                        </div>
                                        <div style="width: 5%; float: left; text-align: center;">
                                          <div style="font-size: 24px; font-weight: 700; margin-top: 20px;">&nbsp;X&nbsp;</div>
                                        </div>
                                        <div style="width: 47.5%; float: left;">
                                          <mat-card style="padding: 0px; margin-top: 10px; width: 100%; height: 45px; background-color: rgb(255, 240, 242);  cursor: pointer;">
                                            <mat-form-field appearance="outline" style="width: 100%; ">
                                              <mat-label style="text-align: left;">
                                                <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                                <b> Resposta</b>
                                                <i>*</i>
                                              </mat-label>
                                              <mat-select formControlName="respDsResposta" style="font-size: 12px; font-weight: 500;">
                                                <mat-option *ngFor="let item of lstBeanAnswer; let i = index"  [hidden]="item.respDhInativo != null" [value]="item.respIdCdResposta">{{item.respDsResposta}}</mat-option>
                                              </mat-select>
                                            </mat-form-field>
                                          </mat-card>
                                        </div>
                                      </div>



                                      <div style="width:100%;  text-align: left; margin-top: 18px;">
                                        <table style="width: 100%;">
                                          <tr>
                                            <td style="width: 100%;">
                                              <div style="width: 15%; float: left;">

                                                <mat-card *ngIf="pergInExtraAux != 'S'" 
                                                            style="float: left; padding: 0px; margin-top: 10px; width: 100%; height: 45px; background-color: rgb(255, 240, 242);  cursor: pointer;">
                                                  <mat-form-field appearance="outline" style="width: 100%; font-family: 'Poppins-ExtraLight';  text-align: center; " >
                                                    <mat-label>
                                                    <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                                    <b> Pontuação</b>
                                                    <i>*</i>
                                                    </mat-label>

                                                    <input matInput formControlName="pontuacaoPXR"
                                                                 maxlength="200" onchange="this.value = this.value.toUpperCase()"
                                                                    style="color: red; font-size: 12px; font-weight: bold; text-align: center;">
                                                  </mat-form-field>
                                                </mat-card>

                                              </div>
                                            
                                              <div  style="width: 15%; float: left;">
                                                <!-- SÓ APARECER PARA FORMULAIO DO TIPO DE PONTUAÇÃO: MÉDIA -->
                                                <mat-card  *ngIf="pergInExtraAux == 'S'" 
                                                              matTooltipPosition="right" matTooltip="A pontuação extra será adicionado ao resultado final da Média."
                                                                style="float: left;padding: 0px; margin-top: 10px; width: 100%; height: 45px; background-color: rgb(255, 240, 242);  cursor: pointer;">

                                                  <mat-form-field 
                                                   
                                                    appearance="outline" style="width: 100%; font-family: 'Poppins-ExtraLight';  text-align: center; " >
                                                    <mat-label>
                                                    <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                                    <b> Ponto Extra </b>
                                                    <i>*</i>
                                                    </mat-label>

                                                    <input matInput formControlName="pontuacaoPXRTrunfo"
                                                                 maxlength="200" onchange="this.value = this.value.toUpperCase()"
                                                                    style="color: red; font-size: 12px; font-weight: bold; text-align: center;">
                                                  </mat-form-field>
                                                </mat-card>


                                              </div>
                                             
                                              <div style="width: 10%; float: left; margin-top: 25px; text-align:right">
                                                <mat-slide-toggle formControlName="defaultPXR" (change)="onChangeDefaultQuestionAnswer($event)" >
                                                  Default
                                               </mat-slide-toggle>
                                              </div>
                                             
                                              <div style="width: 10%; float: left; margin-top: 25px; text-align:center">
                                                <mat-slide-toggle formControlName="zerarPXR"    (change)="bloquearCampoPontuacao($event)">
                                                  Zerar
                                                </mat-slide-toggle>
                                              </div>
                                              
                                              <div style="width: 20%;  float: left; margin-top: 25px; text-align:left">
                                                <mat-slide-toggle formControlName="comentarioPXR">
                                                  Exige comentário
                                                </mat-slide-toggle>
                                              </div>
                                           
                                              <div style="width: 45%; margin-top: 25px; float: left;" *ngIf="this.formulario.controls['idPere'].value == ''">
                                                <div style="width: 70%; float: left;">
                                                  <button mat-raised-button  type="submit"
                                                    style="background-color: rgb(46, 163, 80); color: #fff; width: 99%;  font-size: 12px" (click) = "salvarPergXResp()">
                                                    {{ this.formulario.controls['idPere'].value > 0 ? 'Editar' : 'Criar novo' }}
                                                  </button>
                                                </div>
                                                <div style="width: 30%; float: left;">
                                                  <button mat-raised-button color="warn" style="color: #fff; width: 99%; font-size: 12px;" (click) = "cancelarPergXResp()">
                                                    Cancelar
                                                  </button>
                                                </div>
                                              </div>

                                              <div style="width: 45%; margin-top: 25px; float: left;" *ngIf="this.formulario.controls['idPere'].value != ''">
                                                <div style="width: 40%; float: left;">
                                                  <button mat-raised-button  type="submit"
                                                    style="background-color: rgb(46, 163, 80); color: #fff; width: 99%;  font-size: 12px" (click) = "salvarPergXResp()">
                                                    Editar
                                                  </button>
                                                </div>
                                                <div style="width: 30%; float: left;">
                                                  <button mat-raised-button color="warn" style="color: #fff; width: 99%; font-size: 12px;" (click) = "cancelarPergXResp()">
                                                    Cancelar
                                                  </button>
                                                </div>
                                                <div style="width: 30%; float: left;">
                                                  <button mat-raised-button color="warn"  style="color:#fff; width: 99%; font-size: 12px;"  (click) = "deletePergXResp(this.formulario.controls['idPere'].value)">
                                                    <mat-icon>delete_forever</mat-icon> Excluir
                                                  </button>
                                                </div>
                                              </div>


                                            </td>
                                          </tr>

                                        </table>
                                      </div>







                            </mat-card>
                          </div>
                        <!--DIV DIREITA-->
                        <!--container ajustado dinamicamente-->
                        <div>

                            <div style="margin-top: 0px; height: 5px; width: 100%; background-color: rgb(180, 180, 180)">&nbsp;</div>
                            <mat-card class="mat-elevation-z8" style="padding: 8px;">
                                <!--container ajustado dinamicamente-->

                                    <div style="width: 98%; margin-top: 5px; margin-left: 5px;" >
                                      <mat-form-field class="example-full-width">
                                        <mat-label>Buscar na lista </mat-label>
                                        <input matInput (keyup)="applyFilter($event)" placeholder="Digite a busca de qualquer item na lista abaixo..." #input>
                                      </mat-form-field>
                                    </div>
                                    <div id="subDivContainer" style="width: 100%; ">
                                      <div id="subDivAdjustAutoHeightPergXResp" style="overflow-y: auto; ">
                                        <table mat-table [dataSource]="dataSourceQuestionXAnswers" matSort #sortPergXResp="matSort"
                                          class="mat-elevation-z8" style="width: 98%;  margin-left: 7px; margin-bottom: 3px;  ">

                                          <ng-container matColumnDef="grcaDsGrupoCategoria">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size:12px"> Grupo </th>
                                            <td mat-cell *matCellDef="let element" (click)="setPergXResp(element)" style="width:15%; cursor: pointer;"> {{element.grcaDsGrupoCategoria}} </td>
                                          </ng-container>

                                          <ng-container matColumnDef="cateDsCategoria">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size:12px"> Categoria </th>
                                            <td mat-cell *matCellDef="let element" (click)="setPergXResp(element)" style="width:15%; cursor: pointer;"> {{element.cateDsCategoria}} </td>
                                          </ng-container>


                                          <!-- Position Column -->
                                          <ng-container matColumnDef="pergDsPergunta">
                                          <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size:12px"> Pergunta </th>
                                          <td mat-cell *matCellDef="let element" (click)="setPergXResp(element)" style="width:30%; cursor: pointer;"> {{element.pergDsPergunta}} </td>
                                          </ng-container>
                                          <!-- Position Column -->
                                          <ng-container matColumnDef="respDsResposta">
                                          <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size:12px"> Resposta </th>
                                          <td mat-cell *matCellDef="let element" (click)="setPergXResp(element)" style="width:15%; cursor: pointer;"> {{element.respDsResposta}} </td>
                                          </ng-container>
                                          <!-- Position Column -->
                                          <ng-container matColumnDef="pereNrPonto">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size:12px"> Pontuação </th>
                                            <td mat-cell *matCellDef="let element" (click)="setPergXResp(element)" style="width:5%; cursor: pointer;"> {{element.pereNrPonto}} </td>
                                          </ng-container>
                                           <!-- Position Column -->
                                           <ng-container matColumnDef="pereNrPontoExtra">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size:12px"> Extra </th>
                                            <td mat-cell *matCellDef="let element" (click)="setPergXResp(element)" style="width:5%; cursor: pointer;"> {{element.pereNrPontoExtra}} </td>
                                          </ng-container>
                                          <!-- Symbol Column -->
                                          <ng-container matColumnDef="pereInZerar">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size:12px"> Zerar? </th>
                                            <td mat-cell *matCellDef="let element" (click)="setPergXResp(element)" style="width:5%; cursor: pointer;"> {{element.pereInZerar == 'S' ? 'Sim' : 'Não'}} </td>
                                          </ng-container>
                                           <!-- Symbol Column -->
                                          <ng-container matColumnDef="pereDhInativo">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size:12px"> Inativo? </th>
                                            <td mat-cell *matCellDef="let element" (click)="setPergXResp(element)" style="width:5%; cursor: pointer;"> {{element.pereDhInativo && "Sim" || "Não"}} </td>
                                          </ng-container>
                                          <tr mat-header-row *matHeaderRowDef="displayedColumnsRespostas2; sticky: true" style="height: 15px;"></tr>
                                          <tr mat-row *matRowDef="let row; columns: displayedColumnsRespostas2; " class="aoPassarMouse" style="height: 10px;"></tr>
                                      </table>
                                    </div>
                                </div>
                            </mat-card>
                          </div>
                          </div>
                        </div>
                      </div>
                    </div>
              </mat-tab>

          </mat-tab-group>











      </form>
    </mat-tab>


    <!--MENU CONTEÚDO GLOBAL -->
    <mat-tab *ngFor="let menu of [1];let i=index;" label="📝 Conteúdo Global" >

        <mat-tab-group [(selectedIndex)]="indexConteudoGlobal" (selectedTabChange)="aoMudarSubMenu(indexMenu, indexConteudoGlobal, null);" animationDuration="100ms" style="margin-top: 10px; ">

          <!--MENU FICHAS -->
          <mat-tab label="📝 Perfil " >
            <div style="margin-top: 8px;">
              <!--container ajustado dinamicamente-->
              <div id="divContainer" style="width: 99%;">
                <div id="divAdjustAutoHeight" style="overflow-y: auto;">

                  <div style="margin-left: 5px; margin-right: 5px;">

                    <!--DIV ESQUERDA-->
                    <div style="width: 100%; ">
                      <div style="background-color: rgb(51, 68, 75); height: 30px; width: 100%; color: white; text-align: center; border-radius: 30px 30px 0px 0px;">
                        <div *ngIf="verificaIdSelecionado(formProfile.controls['perfIdCdPerfil'].value)" style=" font-size: 14px;">Novo cadastro</div>
                        <div *ngIf="!verificaIdSelecionado(formProfile.controls['perfIdCdPerfil'].value)" style=" font-size: 14px;">Editar cadastro</div>
                      </div>
                      <div style="margin-top: 0px; height: 5px; width: 100%; background-color: rgb(180, 180, 180)">&nbsp;</div>
                      <mat-card class="mat-elevation-z8" style="padding: 0px;">
                      <!--container ajustado dinamicamente-->
<!--
                            <div id="mode" style="margin-bottom: 10px; display: none;">
                              <p *ngIf="!verificaIdSelecionado(formProfile.controls['perfIdCdPerfil'].value)" style="font-size: small; position: absolute; right: 12px; color: rgb(207, 121, 1); font-weight: bold;">
                                Modo: (Edição)
                              </p>
                              <p *ngIf="verificaIdSelecionado(formProfile.controls['perfIdCdPerfil'].value)" style="font-size: small; position: absolute; right: 12px; color: rgb(46, 163, 80); font-weight: bold;">
                                Modo: (Criação)
                              </p>
                            </div>
                          -->
                              <form [formGroup]="formProfile" novalidate (ngSubmit)="criarProfile()" style="margin-left: 10px; margin-right: 10px;">

                                  <div style="width: 100%;  ">
                                    <div style="width: 11%; float: left;">
                                      <mat-form-field appearance="outline" style="font-family: 'Poppins-ExtraLight'; font-size: 12px;  margin-right: 5px !important;" >
                                        <mat-label>
                                          <b>ID</b>
                                        </mat-label>
                                        <input matInput formControlName="perfIdCdPerfil" maxlength="200" value="this.value" readonly>
                                      </mat-form-field>
                                    </div>
                                    <div style="width: 01%; float: left;">
                                      &nbsp;
                                    </div>
                                    <div style="width: 88%;  float: left;">
                                      <mat-card style="padding: 0px; margin-top: 10px; width: 100%; height: 45px; background-color: rgb(255, 240, 242);  cursor: pointer;">
                                        <mat-form-field appearance="outline" style="font-family: 'Poppins-ExtraLight'; font-size: 12px;" >
                                          <mat-label>
                                            <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                            <b> Nome do Perfil </b>
                                            <i> * </i>
                                          </mat-label>
                                          <input matInput formControlName="perfDsPerfil" maxlength="200" oninput="this.value">
                                        </mat-form-field>
                                      </mat-card>
                                    </div>
                                    <br/> <br/> <br/>
                                  </div>


                                  <div style="width:100%;  text-align: left; margin-top: 18px;">
                                    <table style="width: 100%;">
                                      <tr>
                                        <td style="width: 50%;">
                                          <div style="width: 12%; float: left;">
                                            &nbsp;
                                          </div>
                                          <div style="width: 61%; float: left;">
                                            <mat-slide-toggle formControlName="perfDhInativo" style="font-size: 12px; ">Cadastro inativo?</mat-slide-toggle>

                                          </div>
                                          <div style="width: 17%; float: left;">
                                            <button mat-raised-button  type="submit"
                                              style="background-color: rgb(46, 163, 80); color: #fff; width: 99%;  font-size: 12px">
                                              {{ this.formProfile.controls['perfIdCdPerfil'].value > 0 ? 'Editar' : 'Criar novo' }}
                                            </button>

                                          </div>
                                          <div style="width: 10%; float: left;">
                                            <button mat-raised-button color="warn" type="button" (click)="clearProfile()" style="color: #fff; width: 99%; font-size: 12px ">
                                              Cancelar
                                            </button>
                                          </div>

                                        </td>
                                      </tr>

                                    </table>
                                    <br/>
                                  </div>


                            </form>

                      </mat-card>
                    </div>
                    <!--DIV DIREITA-->
                    <!--container ajustado dinamicamente-->
                    <div style="width: 100%;  margin-right: 5px;">

                      <div style="margin-top: 0px; height: 5px; width: 100%; background-color: rgb(180, 180, 180)">&nbsp;</div>
                      <mat-card class="mat-elevation-z8" style="padding: 8px;">
                        <!--container ajustado dinamicamente-->

                            <div style="width: 98%; margin-top: 5px; margin-left: 5px;" >
                              <mat-form-field class="example-full-width">
                                <mat-label>Buscar na lista </mat-label>
                                <input matInput (keyup)="applyFilter($event)" placeholder="Digite a busca de qualquer item na lista abaixo..." #input>
                              </mat-form-field>
                            </div>

                        <div id="subDivContainer" style="width: 100%; ">
                          <div id="subDivAdjustAutoHeightPerfil" style="overflow-y: auto; ">
                            <table mat-table [dataSource]="dataSourceProfile" matSort #sortProfile="matSort" class="mat-elevation-z8" style="width: 98%;  margin-left: 7px; margin-bottom: 3px;  ">
                              <ng-container matColumnDef="perfDsPerfil">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size:12px"> Nome do Perfil de Monitoria </th>
                                <td mat-cell *matCellDef="let BeanProfile" style="width:80%; cursor: pointer;"> {{BeanProfile.perfDsPerfil}} </td>
                              </ng-container>
                              <ng-container matColumnDef="perfDhInativo">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size:12px"> Inativo?</th>
                                <td mat-cell *matCellDef="let BeanProfile" style="width:20%; cursor: pointer;"> {{BeanProfile.perfDhInativo == null ? "Não" : "Sim"}} </td>
                              </ng-container>
                              <tr mat-header-row *matHeaderRowDef="colunasProfile; sticky: true" style="height: 15px;"></tr>
                              <tr mat-row *matRowDef="let BeanProfileSelecionado; columns: colunasProfile;" (click)="setFormProfile(BeanProfileSelecionado)" class="aoPassarMouse" style="height: 10px;"></tr>
                            </table>
                          </div>
                        </div>
                      </mat-card>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </mat-tab>

          <!--Status da monitoria-->
          <mat-tab  label="📝 Status da monitoria">
            <div style="margin-top: 8px;">
              <!--container ajustado dinamicamente-->
              <div id="divContainer" style="width: 99%;">
                <div id="divAdjustAutoHeight" style="overflow-y: auto;">

                  <div style="margin-left: 5px; margin-right: 5px;">

                    <!--DIV ESQUERDA-->
                    <div style="width: 100%; ">
                      <div style="background-color: rgb(51, 68, 75); height: 30px; width: 100%; color: white; text-align: center; border-radius: 30px 30px 0px 0px;">
                        <div *ngIf="verificaIdSelecionado(formStatus.controls['statIdCdStatus'].value)" style="font-size: 14px;">Novo cadastro</div>
                        <div *ngIf="!verificaIdSelecionado(formStatus.controls['statIdCdStatus'].value)" style="font-size: 14px;">Editar cadastro</div>
                      </div>
                      <div style="margin-top: 0px; height: 5px; width: 100%; background-color: rgb(180, 180, 180)">&nbsp;</div>
                      <mat-card class="mat-elevation-z8" style="padding: 0px;">
                      <!--container ajustado dinamicamente-->

                              <form [formGroup]="formStatus" novalidate (ngSubmit)="criarStatus()" style="margin-left: 10px; margin-right: 10px;">

                                  <div style="width: 100%;  ">
                                    <div style="width: 11%; float: left;">
                                      <mat-form-field appearance="outline" style="font-family: 'Poppins-ExtraLight'; font-size: 12px; margin-right: 5px !important;" >
                                        <mat-label>
                                          <b>ID</b>
                                        </mat-label>
                                        <input matInput formControlName="statIdCdStatus" maxlength="200" value="this.value" readonly>
                                      </mat-form-field>
                                    </div>
                                    <div style="width: 01%; float: left;">
                                      &nbsp;
                                    </div>
                                    <div style="width: 88%;  float: left;">
                                      <mat-card style="padding: 0px; margin-top: 10px; width: 100%; height: 45px; background-color: rgb(255, 240, 242);  cursor: pointer;">
                                        <mat-form-field appearance="outline" style="font-family: 'Poppins-ExtraLight'; font-size: 12px;" >
                                          <mat-label>
                                            <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                            <b> Nome do Status da Monitoria </b>
                                            <i>*</i>
                                          </mat-label>
                                          <input matInput formControlName="statDsStatus" maxlength="200" oninput="this.value">
                                        </mat-form-field>
                                      </mat-card>
                                    </div>
                                    <br/> <br/> <br/>
                                  </div>


                                  <div style="width:100%;  text-align: left; margin-top: 18px;">
                                    <table style="width: 100%;">
                                      <tr>
                                        <td style="width: 50%;">
                                          <div style="width: 12%; float: left;">
                                            &nbsp;
                                          </div>
                                          <div style="width: 61%; float: left;">
                                            <mat-slide-toggle formControlName="statDhInativo" style="font-size: 12px; ">Cadastro inativo?</mat-slide-toggle>

                                          </div>
                                          <div style="width: 17%; float: left;">
                                            <button mat-raised-button  type="submit"
                                              style="background-color: rgb(46, 163, 80); color: #fff; width: 99%;  font-size: 12px">
                                              {{ this.formStatus.controls['statIdCdStatus'].value > 0 ? 'Editar' : 'Criar novo' }}
                                            </button>

                                          </div>
                                          <div style="width: 10%; float: left;">
                                            <button mat-raised-button color="warn" type="button" (click)="clearStatus()" style="color: #fff; width: 99%; font-size: 12px ">
                                              Cancelar
                                            </button>
                                          </div>




                                        </td>
                                      </tr>

                                    </table>
                                    <br/>
                                  </div>


                            </form>

                      </mat-card>
                    </div>
                    <!--DIV DIREITA-->
                    <!--container ajustado dinamicamente-->
                    <div style="width: 100%;  margin-right: 5px;">

                      <div style="margin-top: 0px; height: 5px; width: 100%; background-color: rgb(180, 180, 180)">&nbsp;</div>
                      <mat-card class="mat-elevation-z8" style="padding: 8px;">
                        <!--container ajustado dinamicamente-->

                            <div style="width: 98%; margin-left: 5px;" >
                              <mat-form-field class="example-full-width">
                                <mat-label>Buscar na lista </mat-label>
                                <input matInput (keyup)="applyFilter($event)" placeholder="Digite a busca de qualquer item na lista abaixo..." #input>
                              </mat-form-field>
                            </div>

                            <div id="subDivContainer" style="width: 100%; ">
                              <div id="subDivAdjustAutoHeightStatus" style="overflow-y: auto; ">
                                <table mat-table [dataSource]="status" matSort #sortStatus="matSort" class="mat-elevation-z8" style="width: 98%;  margin-left: 7px; margin-bottom: 3px;" >
                                  <!-- Position Column -->
                                  <ng-container matColumnDef="statDsStatus">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size:12px"> Nome do Status de monitoria </th>
                                    <td mat-cell *matCellDef="let BeanStatus" style="width:20%; cursor: pointer;"> {{BeanStatus.statDsStatus}} </td>
                                  </ng-container>
                                  <!-- Symbol Column -->
                                  <ng-container matColumnDef="statInConfiguracao">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size:12px"> Configuração </th>
                                    <td mat-cell *matCellDef="let BeanStatus" style="width:15%; cursor: pointer;"> {{BeanStatus.statInConfiguracao == "N" ? "Não" : "Sim"}} </td>
                                  </ng-container>
                                  <ng-container matColumnDef="statDhInativo">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size:12px"> Inativo? </th>
                                    <td mat-cell *matCellDef="let BeanStatus" style="width:15%; cursor: pointer;"> {{BeanStatus.statDhInativo == null ? "Não" : "Sim"}} </td>
                                  </ng-container>
                                  <tr mat-header-row *matHeaderRowDef="colunasStatus; sticky: true" style="height: 15px;"></tr>
                                  <tr mat-row *matRowDef="let BeanStatus; columns: colunasStatus;" (click)="validaStatusConfiguracao(BeanStatus.statInConfiguracao) ? clearStatus() : setFormStatus(BeanStatus)"
                                  class="aoPassarMouse" style="height: 10px;" [ngStyle]="BeanStatus.statInConfiguracao == 'S' && {'background-color': 'lightgrey', 'color': 'grey'}"></tr>
                                </table>
                              </div>
                            </div>

                      </mat-card>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </mat-tab>

          <!--Justificativa-->
          <mat-tab  label="📝 Justificativa">
            <div style="margin-top: 8px;">
              <!--container ajustado dinamicamente-->
              <div id="divContainer" style="width: 99%;">
                <div id="divAdjustAutoHeight" style="overflow-y: auto;">

                  <div style="margin-left: 5px; margin-right: 5px;">

                    <!--DIV ESQUERDA-->
                    <div style="width: 100%; ">
                      <div style="background-color: rgb(51, 68, 75); height: 30px; width: 100%; color: white; text-align: center; border-radius: 30px 30px 0px 0px;">
                        <div *ngIf="verificaIdSelecionado(formJustificativa.controls['justIdCdJustificativa'].value)" style="font-size: 14px;">Novo cadastro</div>
                        <div *ngIf="!verificaIdSelecionado(formJustificativa.controls['justIdCdJustificativa'].value)" style="font-size: 14px;">Editar cadastro</div>
                      </div>
                      <div style="margin-top: 0px; height: 5px; width: 100%; background-color: rgb(180, 180, 180)">&nbsp;</div>
                      <mat-card class="mat-elevation-z8" style="padding: 0px;">
                      <!--container ajustado dinamicamente-->

                              <form [formGroup]="formJustificativa" novalidate (ngSubmit)="criarJustificativa()" style="margin-left: 10px; margin-right: 10px;">

                                  <div style="width: 100%;  ">
                                    <div style="width: 11%; float: left;">
                                      <mat-form-field appearance="outline" style="font-family: 'Poppins-ExtraLight'; font-size: 12px; margin-right: 5px !important;" >
                                        <mat-label>
                                          <b>ID</b>
                                        </mat-label>
                                        <input matInput formControlName="justIdCdJustificativa" maxlength="200" value="this.value" readonly>
                                      </mat-form-field>
                                    </div>
                                    <div style="width: 01%; float: left;">
                                      &nbsp;
                                    </div>
                                    <div style="width: 88%;  float: left;">
                                      <mat-card style="padding: 0px; margin-top: 10px; width: 100%; height: 45px; background-color: rgb(255, 240, 242);  cursor: pointer;">
                                        <mat-form-field appearance="outline" style="font-family: 'Poppins-ExtraLight'; font-size: 12px;" >
                                          <mat-label>
                                            <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                            <b> Nome da Justificativa </b>
                                            <i>*</i>
                                          </mat-label>
                                          <input matInput formControlName="justDsJustificativa" maxlength="200" oninput="this.value" [readonly]="isReadonly">
                                        </mat-form-field>
                                      </mat-card>
                                    </div>
                                    <br/> <br/> <br/>
                                  </div>


                                  <div style="width:100%;  text-align: left; margin-top: 18px;">
                                    <table style="width: 100%;">
                                      <tr>
                                        <td style="width: 50%;">
                                          <div style="width: 12%; float: left;">
                                            &nbsp;
                                          </div>
                                          <div style="width: 61%; float: left;">
                                            <mat-slide-toggle formControlName="justDhInativo" style="font-size: 12px; ">Cadastro inativo?</mat-slide-toggle>

                                          </div>
                                          <div style="width: 17%; float: left;">
                                            <button mat-raised-button  type="submit"
                                              style="background-color: rgb(46, 163, 80); color: #fff; width: 99%;  font-size: 12px">
                                              {{ this.formJustificativa.controls['justIdCdJustificativa'].value > 0 ? 'Editar' : 'Criar novo' }}
                                            </button>

                                          </div>
                                          <div style="width: 10%; float: left;">
                                            <button mat-raised-button color="warn" type="button" (click)="clearJustificativa()" style="color: #fff; width: 99%; font-size: 12px ">
                                              Cancelar
                                            </button>
                                          </div>




                                        </td>
                                      </tr>

                                    </table>
                                    <br/>
                                  </div>


                            </form>

                      </mat-card>
                    </div>
                    <!--DIV DIREITA-->
                    <!--container ajustado dinamicamente-->
                    <div style="width: 100%;  margin-right: 5px;">

                      <div style="margin-top: 0px; height: 5px; width: 100%; background-color: rgb(180, 180, 180)">&nbsp;</div>
                      <mat-card class="mat-elevation-z8" style="padding: 8px;">
                        <!--container ajustado dinamicamente-->

                            <div style="width: 98%; margin-left: 5px;" >
                              <mat-form-field class="example-full-width">
                                <mat-label>Buscar na lista </mat-label>
                                <input matInput (keyup)="applyFilter($event)" placeholder="Digite a busca de qualquer item na lista abaixo..." #input>
                              </mat-form-field>
                            </div>

                            <div id="subDivContainer" style="width: 100%; ">
                              <div id="subDivAdjustAutoHeightJustificativa" style="overflow-y: auto; ">
                                <table mat-table [dataSource]="justificativa" matSort #sortJustificativa="matSort" class="mat-elevation-z8" style="width: 98%;  margin-left: 7px; margin-bottom: 3px;" >
                                  <!-- Position Column -->
                                  <ng-container matColumnDef="justDsJustificativa">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size:12px"> Nome da Justificativa </th>
                                    <td mat-cell *matCellDef="let BeanJustificativa" style="width:20%; cursor: pointer;"> {{BeanJustificativa.justDsJustificativa}} </td>
                                  </ng-container>
                                  <!-- Symbol Column -->
                                  <ng-container matColumnDef="justDhInativo">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size:12px"> Inativo? </th>
                                    <td mat-cell *matCellDef="let BeanJustificativa" style="width:15%; cursor: pointer;"> {{BeanJustificativa.justDhInativo == null ? "Não" : "Sim"}} </td>
                                  </ng-container>
                                  <tr mat-header-row *matHeaderRowDef="colunasJustificativa; sticky: true" style="height: 15px;"></tr>
                                  <tr mat-row *matRowDef="let BeanJustificativa; columns: colunasJustificativa;" (click)="setFormJustificativa(BeanJustificativa)"
                                  style="height: 10px;" class="aoPassarMouse"></tr>
                                </table>
                              </div>
                            </div>

                      </mat-card>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>
    </mat-tab>

    <!--MENU ESTRUTURA -->
    <!--
    <mat-tab style="display: none;" *ngFor="let menu of [2];let i=index;" label="📝 Estrutura">
      <form [formGroup]="formulario" novalidate >

        <div style=" width: 100%; overflow:hidden; text-align: center;">

          <div style="width: 100%; height: 60px; background-color: rgb(51, 68, 75); text-align: center;">

                <table style="width: 98%; margin-left: 10px;   ">
                  <tr>
                    <td style="width: 100%;  ">

                      <div style="float: left; width: 50%; ">
                        <mat-card style="padding: 0px;  width: 50%;   height: 47px; margin: auto; margin-top: 5px;">
                          <mat-form-field appearance="outline" style="width: 100%; font-size: 11px; text-align: center;">
                            <mat-label style="text-align: left;">
                              <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                              <b> Operação</b>
                              <i>(Empresa)</i>
                            </mat-label>
                            <mat-select formControlName="operacao" style="text-align: center; font-size: 16px; font-weight: 500;">
                              <mat-option value="1">Adidas</mat-option>
                              <mat-option value="2">Bayer</mat-option>
                              <mat-option value="3">Bristol</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </mat-card>
                      </div>
                      <div style="float: left; width: 50%;">
                        <mat-card style="padding: 0px;  width: 50%; height: 47px; margin: auto; margin-top: 5px;">
                          <mat-form-field appearance="outline" style="width: 100%; font-size: 11px; text-align: center;">
                            <mat-label style="text-align: left;">
                              <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                              <b> Ficha</b>
                              <i>(formulário)</i>
                            </mat-label>
                            <mat-select formControlName="operacao" style="text-align: center; font-size: 16px; font-weight: 500;">
                              <mat-option value="1">Formulario 1</mat-option>
                              <mat-option value="2">Formulario 2</mat-option>
                              <mat-option value="3">Formulario 3</mat-option>
                              <mat-option value="4">Formulario 3</mat-option>
                              <mat-option value="5">Formulario 3</mat-option>
                              <mat-option value="6">Formulario 3</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </mat-card>
                      </div>

                    </td>

                  </tr>

                </table>

          </div>
          <div style="margin-top: 0px; height: 5px; width: 100%; background-color: rgb(180, 180, 180)">&nbsp;</div>

        </div>

    <div style="margin-top: 8px;">

      <div id="divContainerEstrutura" style="width: 99%;">

        <div id="divAdjustAutoHeightEstrutura" style="overflow-y: auto;">

          <div style="margin-left: 5px; margin-right: 5px;">




          <div style="width: 99%; height: 570px; ">


            <div id="menu" >
              <mat-card class="mat-elevation-z8" style="padding: 8px; font-weight: 550;">
                  <table style="width: 100%; border: 1px solid;  text-align: center">
                      <tr>

                          <td  style="width: 15%; background-color: lightgreen">
                              Nome da Ficha
                          </td>
                          <td style="width: 85%;">
                              <table style="width: 100%;">
                                  <tr>
                                      <td style="width: 20%; background-color: lightblue;">
                                      Grupo de Categoria
                                      </td>
                                      <td style="width: 80%;">
                                          <table style="width: 100%; ">
                                              <tr>
                                                  <td style="width: 25%; background-color: lightpink; ">
                                                  Categoria
                                                  </td>
                                                  <td style="width: 75%; ">
                                                      <table style="width: 100%; ">
                                                          <tr>
                                                              <td style="width: 50%; background-color: #DDBDF1;">
                                                              Pergunta
                                                              </td>
                                                              <td style="width: 50%; ">
                                                                  <table style="width: 100%; ">
                                                                      <tr>
                                                                          <td style="width: 100%; background-color: lightgray">
                                                                              Resposta
                                                                          </td>
                                                                      </tr>
                                                                  </table>
                                                              </td>
                                                          </tr>
                                                      </table>
                                                  </td>
                                              </tr>
                                          </table>
                                      </td>
                                  </tr>
                              </table>
                          </td>
                      </tr>
                  </table>
          </mat-card>







      </div>

      <div style="margin-top: 20px ;">
          <mat-card class="mat-elevation-z8" style="padding: 8px; ">
                  <table class="tableEstruturaFormularios"  style="width: 100%; border: 1px solid; text-align: center; ">


                      <tr>


                          <td  style="width: 15%; background-color: lightgreen; ">
                              Ficha atendimento 0800
                          </td>

                          <td style="width: 85%;">

                              <table style="width: 100%;">
                                  <tr style="border-bottom: 1px solid white">
                                      <td style="width: 20%; background-color: lightblue;">
                                          Técnico
                                      </td>
                                      <td style="width: 80%;">
                                          <table style="width: 100%; ">
                                              <tr style="border-bottom: 1px solid white">
                                                  <td style="width: 25%; background-color: lightpink; ">
                                                      Abertura / Fechamento
                                                  </td>

                                                  <td style="width: 75%; ">
                                                      <table style="width: 100%; ">
                                                          <tr style="border-bottom: 1px solid white">
                                                              <td style="width: 50%; background-color: #DDBDF1;">
                                                                  Atendeu prontamente a chamada?
                                                              </td>
                                                              <td style="width: 50%; ">
                                                                  <table style="width: 100%; ">
                                                                      <tr style="border-bottom: 1px solid white">
                                                                          <td style="width: 100%; background-color: lightgray">
                                                                              Conforme
                                                                          </td>
                                                                      </tr>
                                                                      <tr style="border-bottom: 1px solid white">
                                                                          <td style="width: 100%; background-color: lightgray">
                                                                              Não Conforme
                                                                          </td>
                                                                      </tr>
                                                                      <tr style="border-bottom: 1px solid white">

                                                                          <td style="width: 100%; background-color: lightgray">
                                                                              NA
                                                                          </td>

                                                                      </tr>
                                                                  </table>

                                                              </td>
                                                          </tr>
                                                          <tr>
                                                              <td style="width: 50%; background-color: #DDBDF1;">
                                                                  Fez a Abertura/Fechamento de maneira adequada?
                                                              </td>
                                                              <td style="width: 50%;">
                                                                  <table style="width: 100%; ">
                                                                      <tr style="border-bottom: 1px solid white">
                                                                          <td style="width: 100%; background-color: lightgray">
                                                                              Conforme
                                                                          </td>
                                                                      </tr>
                                                                      <tr style="border-bottom: 1px solid white">
                                                                          <td style="width: 100%; background-color: lightgray">
                                                                              Não Conforme
                                                                          </td>
                                                                      </tr>
                                                                      <tr style="border-bottom: 1px solid white">

                                                                          <td style="width: 100%; background-color: lightgray">
                                                                              NA
                                                                          </td>

                                                                      </tr>
                                                                  </table>

                                                              </td>
                                                          </tr>

                                                      </table>
                                                  </td>

                                              </tr>
                                              <tr>
                                                  <td style="width: 25%;background-color: lightpink">
                                                      Atendimento
                                                  </td>
                                                  <td style="width: 75%; width: 100%; ">
                                                      <table style="width: 100%;">
                                                          <table style="width: 100%; ">
                                                              <tr style="border-bottom: 1px solid white">
                                                                  <td style="width: 50%; background-color: #DDBDF1;">
                                                                      Sinalizou o cliente?
                                                                  </td>
                                                                  <td style="width: 50%; ">
                                                                      <table style="width: 100%; ">
                                                                          <tr style="border-bottom: 1px solid white">
                                                                              <td style="width: 100%; background-color: lightgray">
                                                                                  Conforme
                                                                              </td>
                                                                          </tr>
                                                                          <tr style="border-bottom: 1px solid white">
                                                                              <td style="width: 100%; background-color: lightgray">
                                                                                  Não Conforme
                                                                              </td>
                                                                          </tr>
                                                                          <tr style="border-bottom: 1px solid white">

                                                                              <td style="width: 100%; background-color: lightgray">
                                                                                  NA
                                                                              </td>

                                                                          </tr>
                                                                      </table>

                                                                  </td>
                                                              </tr>

                                                          </table>

                                                      </table>
                                                  </td>
                                              </tr>
                                          </table>
                                      </td>

                                  </tr>
                                  <tr style="border-bottom: 1px solid white">
                                      <td style="width: 20%; background-color: lightblue;">
                                          Habilidade de comunicação
                                      </td>
                                      <td style="width: 80%;">
                                          <table style="width: 100%; ">
                                              <tr style="border-bottom: 1px solid white">
                                                  <td style="width: 25%; background-color: lightpink; ">
                                                      Linguagem
                                                  </td>

                                                  <td style="width: 75%; ">
                                                      <table style="width: 100%; ">
                                                          <tr style="border-bottom: 1px solid white">
                                                              <td style="width: 50%; background-color: #DDBDF1;">
                                                                  Apresentou boa comunicação verbal?
                                                              </td>
                                                              <td style="width: 50%; ">
                                                                  <table style="width: 100%; ">
                                                                      <tr style="border-bottom: 1px solid white">
                                                                          <td style="width: 100%; background-color: lightgray">
                                                                              Conforme
                                                                          </td>
                                                                      </tr>
                                                                      <tr style="border-bottom: 1px solid white">
                                                                          <td style="width: 100%; background-color: lightgray">
                                                                              Não Conforme
                                                                          </td>
                                                                      </tr>
                                                                      <tr style="border-bottom: 1px solid white">

                                                                          <td style="width: 100%; background-color: lightgray">
                                                                              NA
                                                                          </td>

                                                                      </tr>
                                                                  </table>

                                                              </td>
                                                          </tr>

                                                      </table>
                                                  </td>

                                              </tr>
                                              <tr style="border-bottom: 1px solid white">
                                                  <td style="width: 25%; background-color: lightpink; ">
                                                      Comunicação
                                                  </td>
                                                  <td style="width: 75%; ">
                                                      <table style="width: 100%; ">
                                                          <tr style="border-bottom: 1px solid white">
                                                              <td style="width: 50%; background-color: #DDBDF1;">
                                                                  Apresentou boa comunicação verbal?
                                                              </td>
                                                              <td style="width: 50%; ">
                                                                  <table style="width: 100%; ">
                                                                      <tr style="border-bottom: 1px solid white">
                                                                          <td style="width: 100%; background-color: lightgray">
                                                                              Conforme
                                                                          </td>
                                                                      </tr>
                                                                      <tr style="border-bottom: 1px solid white">
                                                                          <td style="width: 100%; background-color: lightgray">
                                                                              Não Conforme
                                                                          </td>
                                                                      </tr>
                                                                      <tr style="border-bottom: 1px solid white">

                                                                          <td style="width: 100%; background-color: lightgray">
                                                                              NA
                                                                          </td>

                                                                      </tr>
                                                                  </table>

                                                              </td>
                                                          </tr>
                                                          <tr style="border-bottom: 1px solid white">
                                                              <td style="width: 50%; background-color: #DDBDF1;">
                                                                  Apresentou empatia? Foi acolhedor? Estabeleceu conexão emocional com o cliente?
                                                              </td>
                                                              <td style="width: 50%; ">
                                                                  <table style="width: 100%; ">
                                                                      <tr style="border-bottom: 1px solid white">
                                                                          <td style="width: 100%; background-color: lightgray">
                                                                              Conforme
                                                                          </td>
                                                                      </tr>
                                                                      <tr style="border-bottom: 1px solid white">
                                                                          <td style="width: 100%; background-color: lightgray">
                                                                              Não Conforme
                                                                          </td>
                                                                      </tr>
                                                                      <tr style="border-bottom: 1px solid white">

                                                                          <td style="width: 100%; background-color: lightgray">
                                                                              NA
                                                                          </td>

                                                                      </tr>
                                                                  </table>

                                                              </td>
                                                          </tr>
                                                          <tr style="border-bottom: 1px solid white">
                                                              <td style="width: 50%; background-color: #DDBDF1;">
                                                                  Personalizou o contato?
                                                              </td>
                                                              <td style="width: 50%; ">
                                                                  <table style="width: 100%; ">
                                                                      <tr style="border-bottom: 1px solid white">
                                                                          <td style="width: 100%; background-color: lightgray">
                                                                              Conforme
                                                                          </td>
                                                                      </tr>
                                                                      <tr style="border-bottom: 1px solid white">
                                                                          <td style="width: 100%; background-color: lightgray">
                                                                              Não Conforme
                                                                          </td>
                                                                      </tr>
                                                                      <tr style="border-bottom: 1px solid white">

                                                                          <td style="width: 100%; background-color: lightgray">
                                                                              NA
                                                                          </td>

                                                                      </tr>
                                                                  </table>

                                                              </td>
                                                          </tr>
                                                          <tr style="border-bottom: 1px solid white">
                                                              <td style="width: 50%; background-color: #DDBDF1;">
                                                                  Entendeu a real necessidade do cliente?
                                                              </td>
                                                              <td style="width: 50%; ">
                                                                  <table style="width: 100%; ">
                                                                      <tr style="border-bottom: 1px solid white">
                                                                          <td style="width: 100%; background-color: lightgray">
                                                                              Conforme
                                                                          </td>
                                                                      </tr>
                                                                      <tr style="border-bottom: 1px solid white">
                                                                          <td style="width: 100%; background-color: lightgray">
                                                                              Não Conforme
                                                                          </td>
                                                                      </tr>
                                                                      <tr style="border-bottom: 1px solid white">

                                                                          <td style="width: 100%; background-color: lightgray">
                                                                              NA
                                                                          </td>

                                                                      </tr>
                                                                  </table>

                                                              </td>
                                                          </tr>
                                                          <tr style="border-bottom: 1px solid white">
                                                              <td style="width: 50%; background-color: #DDBDF1;">
                                                                  Apresentou atenção durante o atendimento?
                                                              </td>
                                                              <td style="width: 50%; ">
                                                                  <table style="width: 100%; ">
                                                                      <tr style="border-bottom: 1px solid white">
                                                                          <td style="width: 100%; background-color: lightgray">
                                                                              Conforme
                                                                          </td>
                                                                      </tr>
                                                                      <tr style="border-bottom: 1px solid white">
                                                                          <td style="width: 100%; background-color: lightgray">
                                                                              Não Conforme
                                                                          </td>
                                                                      </tr>
                                                                      <tr style="border-bottom: 1px solid white">

                                                                          <td style="width: 100%; background-color: lightgray">
                                                                              NA
                                                                          </td>

                                                                      </tr>
                                                                  </table>

                                                              </td>
                                                          </tr>
                                                          <tr style="border-bottom: 1px solid white">
                                                              <td style="width: 50%; background-color: #DDBDF1;">
                                                                  Foi dono do contato?
                                                              </td>
                                                              <td style="width: 50%; ">
                                                                  <table style="width: 100%; ">
                                                                      <tr style="border-bottom: 1px solid white">
                                                                          <td style="width: 100%; background-color: lightgray">
                                                                              Conforme
                                                                          </td>
                                                                      </tr>
                                                                      <tr style="border-bottom: 1px solid white">
                                                                          <td style="width: 100%; background-color: lightgray">
                                                                              Não Conforme
                                                                          </td>
                                                                      </tr>
                                                                      <tr style="border-bottom: 1px solid white">

                                                                          <td style="width: 100%; background-color: lightgray">
                                                                              NA
                                                                          </td>

                                                                      </tr>
                                                                  </table>

                                                              </td>
                                                          </tr>
                                                          <tr style="border-bottom: 1px solid white">
                                                              <td style="width: 50%; background-color: #DDBDF1;">
                                                                  Apresentou erros de escrita?
                                                              </td>
                                                              <td style="width: 50%; ">
                                                                  <table style="width: 100%; ">
                                                                      <tr style="border-bottom: 1px solid white">
                                                                          <td style="width: 100%; background-color: lightgray">
                                                                              Conforme
                                                                          </td>
                                                                      </tr>
                                                                      <tr style="border-bottom: 1px solid white">
                                                                          <td style="width: 100%; background-color: lightgray">
                                                                              Não Conforme
                                                                          </td>
                                                                      </tr>
                                                                      <tr style="border-bottom: 1px solid white">

                                                                          <td style="width: 100%; background-color: lightgray">
                                                                              NA
                                                                          </td>

                                                                      </tr>
                                                                  </table>

                                                              </td>
                                                          </tr>


                                                      </table>
                                                  </td>

                                              </tr>

                                          </table>
                                      </td>

                                  </tr>


                              </table>
                          </td>

                      </tr>

                  </table>
          </mat-card>
      </div>





          </div>


          </div>

        </div>

      </div>

    </div>

      </form>
    </mat-tab> -->

  </mat-tab-group>

</div>
